import React, { Component } from "react";
import SimpleReactValidator from "simple-react-validator";
import $ from "jquery";
import SoaDocument from "../soapdf/SoaDocument";
import ConfPdf from "../Pdfs/ConfPdf";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import Step1 from "./Step1.jsx";
import Step3 from "./Step3.jsx";
import Soa from "./Soa.jsx";
import Step2 from "./Step2.jsx";
import Step4Agent from "./Setp4Agent.jsx";
import Step5Agent from "./Step5Agent.js";
import { INITIAL_STATE } from "../initialState";
import { connect } from "react-redux";
import LinearProgress from "@material-ui/core/LinearProgress";
import { withStyles } from "@material-ui/core/styles";
import * as DateUtil from "../../Utils/DatePicker";
import { handleDateChange } from "../../Utils/DateFormatter";
import { handleDateChangeNew } from "../../Utils/DateFormatter1";
import ReactGA from "react-ga";
//import Captcha from "../Captcha/Captcha";
import StepperSidebar from "./StepperSidebar";
import Footer from "../../Themes/Footer";
import {
  VERDA_CONSTS,
  NEBRASKA_CONSTS,
  ILS_CONSTS,
  poArray,
} from "../../Utils/StaticData/Constant";
import {
  getsepReasons,
  setLoginStateValues,
  downloadFormsPdf,
  mbiDetails,
  getMailZipCodes,
  getStates,
  planSelectionContinue,
  saveLogout,
  submitForm,
  setTokenTORedux,
  getClinicalName,
  removeplan,
  checkEligibility,
  getZipCodes,
  setStateParams,
  setCampaignProspectStateParams,
  setLoginStateParams,
  getPlans,
  uploadFile,
  uploadSign,
  deleteFile,
  setPendingApplFlag,
  LogoutToken,
  setSpinner,
  getCityList,
  getltcList,
  //captchaValidation,
  setPageName,
  getPcpList,
  setPcpData,
  getAgentList,
} from "../../Redux/Actions/webAppActions";
import history from "../../Utils/History";
import { Text, setLanguage } from "react-internationalization";
import moment from "moment";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import Step2Med from "../Step2Med.jsx";
import { FieldLabel } from "../translations/dynamic";
import { data } from "jquery";
const PLANS = [
  {
    planId: "1",
    name: "Wipro Select Medicare Advantage Only",
  },
  {
    planId: "2",
    name: "Wipro Elite Health Medicare Prime HMO",
  },
  {
    planId: "3",
    name: "Wipro Managed Health Medicare Prime HMO with Dental/Vison",
  },
  {
    planId: "4",
    name: "Wipro Elite Health Medicare PPO Rx",
  },
  {
    planId: "5",
    name: "Wipro Elite Health Medicare PPO Rx with Dental/Vison",
  },
  {
    planId: "6",
    name: "Wipro Elite Health Medicare PDP",
  },
  {
    planId: "7",
    name: "Wipro Platinum Health Medicare PDP",
  },
  {
    planId: "8",
    name: "Wipro Prime Health Medigap Plan (F)",
  },
  {
    planId: "9",
    name: "Wipro Prime Health Medigap Plan (G)",
  },
  {
    planId: "10",
    name: "Wipro Prime Health Medigap Plan (A)",
  },
  {
    planId: "11",
    name: "Wipro Prime Health Medigap Plan (B)",
  },
];
const typeOfFilesToUploadAgent = [
  {
    label: "--Select--",
    value: "",
    typeCode: "",
  },
  {
    label: "ID INFORMATION",
    value: "idInf",
    typeCode: "IDIN",
  },
  {
    label: "MEDICARE CARD",
    value: "medCard",
    typeCode: "MCR",
  },
  {
    label: "PAPER ENROLLMENT",
    value: "PAPER",
    typeCode: "PPR",
  },
  {
    label: "OTHERS",
    value: "misc",
    typeCode: "OTHR",
  },
];
const typeOfFilesToUpload = [
  {
    label: "--Select--",
    value: "",
    typeCode: "",
  },
  {
    label: "ID INFORMATION",
    value: "idInf",
    typeCode: "IDIN",
  },
  {
    label: "MEDICARE CARD",
    value: "medCard",
    typeCode: "MCR",
  },
  {
    label: "OTHERS",
    value: "misc",
    typeCode: "OTHR",
  },
];
const uploadFiles = [
  {
    label: "SOA",
    value: "",
  },
  {
    label: "ID INFORMATION",
    value: "",
  },
  {
    label: "MEDICARE CARD",
    value: "",
  },
  {
    label: "OTHERS",
    value: "",
  },
];
const styles = (props) => ({
  progressComplete: {
    backgroundColor: "#00695C",
  },
  root: {
    height: "20px",
  },
  progressIncomplete: {
    backgroundColor: "#3f51b5",
  },
});
let validCheck = true;
let validEmail = true;
let lang = "en";
let currentYear,
  currentMonth,
  // nxtFirstMonth,
  // nxtSecondMonth,
  // nxtThirdMonth,
  nxtFirstMonthYear,
  nxtSecondMonthYear,
  nxtThirdMonthYear;
class PreEnrollForm extends Component {
  constructor(props) {
    super(props);
    this.uploadFiles =
      Object.keys(this.props.preEnrollInfo).length === 0
        ? uploadFiles
        : [
            {
              label: "SOA",
              value: this.props.preEnrollInfo.soa,
            },
            {
              label: "ID INFORMATION",
              value: this.props.preEnrollInfo.idInf,
            },
            {
              label: "MEDICARE CARD",
              value: this.props.preEnrollInfo.medCard,
            },
            {
              label: "OTHERS",
              value: this.props.preEnrollInfo.misc,
            },
          ];
    this.state = {
      selectedQnId: [],
      scrollCount: 0,
      methodOfContactfilled: true,
      mandatoryMbi: "",
      attestationList: [],
      questionDate: [],
      stepVal: this.props.agentLogin
        ? this.props.isUpdated || this.props.prospectEnroll
          ? "step1"
          : this.props.productName === "Medicare Supplement"
          ? "step1"
          : "step0"
        : "step1",
      data:
        Object.keys(this.props.preEnrollInfo).length === 0
          ? { ...INITIAL_STATE }
          : this.props.preEnrollInfo,
      disableCheck: false,
      authorizedrelations: this.props.authorizedrelations,
      selectedPlan: "",
      questionIdSelected: "",
      checkName: "",
      snackBarOpen: false,
      alertMsg: "",
      severity: "",
      vertical: "top",
      horizontal: "center",
      selectedFiles: [],
      urlList: [],
      viewurl: "",
      SOA: {},
      // typeOfFilesToUpload: this.props.typeOfFilesToUpload,
      // this.props.agentLogin === true &&
      // this.props.customerId === VERDA_CONSTS.ID
      //   ? typeOfFilesToUploadAgent
      //   : this.props.customerId === NEBRASKA_CONSTS.ID
      //   ? typeOfFilesToUploadAgent
      //   : typeOfFilesToUpload,
      fileType: "",
      setPCP: true,
      formatphone: true,
      dateInd: [{ dateInd: "n" }],
      isInitial: true,
      isSoaFilled: false,
      partAvalid: true,
      partBvalid: true,
      proposedvalid: true,
      isValidpermntZip4: true,
      isValidmailZip4: true,
      isValidauthZip4: true,
      // isStepBar:true
    };
    this.mbiFlag = 0;
    this.progress = "";
    this.AuthAddressFilled = true;
    this.mailingAddressFilled = true;
    this.isProgressCompleted = false;
    this.validator = new SimpleReactValidator();
    this.dateArray = [];
    this.verdaFilesUploaded = [];
  }
  //payload updating

  unload = () => {
    console.log("page unloaded");
  };

  updateAddressFields = () => {
    if (
      this.props?.preEnrollInfo &&
      this.props?.preEnrollInfo.permanentAddress
    ) {
      const { city, county, state, address2, streetAddress, zipCode, zip4 } =
        this.props?.preEnrollInfo?.permanentAddress;

      this.setState((prevState) => ({
        data: {
          ...prevState.data,
          state,
          permanentCity: city,
          county,
          permanentAddrStreet: streetAddress,
          permanentZip4: zip4,
          permanentAddr2: address2,
          zipCode,
        },
      }));
    }
    if (this.props?.preEnrollInfo && this.props?.preEnrollInfo.mailingAddress) {
      const {
        city,
        state,
        streetAddress,
        address2,
        zipCode,
        zip4,
        county,
        countyCd,
      } = this.props?.preEnrollInfo?.mailingAddress;
      let mailingAddressRequired =
        JSON.stringify(this.props?.preEnrollInfo?.mailingAddress) ===
        JSON.stringify(this.props?.preEnrollInfo?.permanentAddress)
          ? "YES"
          : "";
      this.setState((prevState) => ({
        data: {
          ...prevState.data,
          mailingState: state,
          mailingCity: city,
          mailingCounty: county,
          mailingCountyCd: countyCd,
          county: "",
          mailingAddr: streetAddress,
          mailingZip4: zip4,
          mailingAddr2: address2,
          mailingzip: zipCode,
          mailingAddressRequired,
        },
      }));
    }
    if (this.props?.preEnrollInfo && this.props?.preEnrollInfo.authRepAddress) {
      const { streetAddress, address2, address3, city, state, zipCode, zip4 } =
        this.props?.preEnrollInfo?.authRepAddress;

      this.setState((prevState) => ({
        data: {
          ...prevState.data,
          authRepState: state,
          authRepCity: city,
          addressOfRep2: address2,
          addressOfRep: streetAddress,
          address3,
          authZip4: zip4,
          authRepZip: zipCode,
        },
      }));
    }
  };
  handleScroll = () => {
    let flag = false;
    let set = document.getElementsByClassName("scrollfix");
    Object.entries(set).map(([key, value]) => {
      if (
        Object.values(value.classList).some((item) => item === "hasDatepicker")
      ) {
        flag = true;
      }
    });

    if (flag) {
      this.setState({
        ...this.state,
        scrollCount: this.state.scrollCount + 1,
      });
    }
  };
  async componentDidMount() {
    this.state.data.agentTaxId = this.props.agentTaxId;
    this.state.data.agentEmail = this.props.agentEmailId;
    this.state.data.enrlDate = this.state.data.enrlDate
      ? this.state.data.enrlDate
      : new Date()
          .toLocaleString("es-pa", {
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          })
          .split(",")[0];
    if (this?.props?.deeplink === true) {
      this.setState({
        ...this.state,
        data: {
          ...this.state.data,
          permanentCounty: this?.props?.dpcountyName,
        },
      });
    }
    //await this.props.setLoginStateParams("sepReasonforS",[])
    await this.props?.setStateParams("electionType", "S");
    if (this?.props?.productId) {
      this.setState({
        ...this.state,
        data: {
          ...this.state.data,
          productId: this?.props?.productId,
        },
      });
    }
    this.props.setStateParams("previewToSelectplan", false);
    window.addEventListener("scroll", this.handleScroll, true);
    {
      JSON.parse(window.sessionStorage.getItem("agentLoggedIn")) &&
        this.props.setLoginStateParams(
          "agentLoggedIn",
          JSON.parse(window.sessionStorage.getItem("agentLoggedIn"))
        );
    }
    {
      JSON.parse(window.sessionStorage.getItem("beneficiaryLogin")) &&
        this.props.setLoginStateParams(
          "beneficiaryLogin",
          JSON.parse(window.sessionStorage.getItem("beneficiaryLogin"))
        );
    }
    {
      JSON.parse(window.sessionStorage.getItem("guestLogin")) &&
        this.props.setLoginStateParams(
          "guestLogin",
          JSON.parse(window.sessionStorage.getItem("guestLogin"))
        );
    }
    if (
      this?.state?.data.medicareNumber === "" ||
      this?.state?.data.proposedEffDate === ""
    ) {
      this.mbiFlag = 1;
    }
    this.props.setStateParams("selectedVo", {});
    this.props.setStateParams("pcpDetails", {});
    if (!this.props.pendingApplFlag) {
      this.props.setStateParams("selectedIndex", null);
      this.props.setStateParams("permanentAddrStreet", null);
      this.props.setStateParams("permanentCity", null);
      this.props.setStateParams("permanentZip", null);
      this.props.setStateParams("physiciansData", []);
    }
    this.props.getltcList(this.props?.customerId);
    this.props.getAgentList(this.props?.customerId);

    if (
      this.props?.agentLogin === true ||
      this.props?.beneficiaryLogin === true
    ) {
      this.props.setStateParams("isCaptchaValidated", true);
    }
    this.props.setPageName("enrollOnline");
    // zipCode

    if (this.props.agentLogin === true) {
      // if (
      //   this.props.soa?.MA1 === "YES" ||
      //   this.props?.soa?.productIds?.includes("MA1")
      // ) {
      //   await this.setState({
      //     productIds: {
      //       ...this.state.productIds,
      //       MA1: "YES",
      //     },
      //   });
      // }
      // if (
      //   this.props.soa?.DSNP === "YES" ||
      //   this.props?.soa?.productIds?.includes("DSNP")
      // ) {
      //   await this.setState({
      //     productIds: {
      //       ...this.state.productIds,
      //       DSNP: "YES",
      //     },
      //   });
      // }
      // if (
      //   this.props.soa?.E005 === "YES" ||
      //   this.props?.soa?.productIds?.includes("E005")
      // ) {
      //   await this.setState({
      //     productIds: {
      //       ...this.state.productIds,
      //       E005: "YES",
      //     },
      //   });
      // }
      // if (
      //   this.props.soa?.E006 === "YES" ||
      //   this.props?.soa?.productIds?.includes("E006")
      // ) {
      //   await this.setState({
      //     productIds: {
      //       ...this.state.productIds,
      //       E006: "YES",
      //     },
      //   });
      // }
      // if (
      //   this.props.soa?.PDP1 === "YES" ||
      //   this.props?.soa?.productIds?.includes("PDP1")
      // ) {
      //   await this.setState({
      //     productIds: {
      //       ...this.state.productIds,
      //       PDP1: "YES",
      //     },
      //   });
      // }
      //changing the soa key  productname to productIds so that while enroll through prospectdashboard the soa form work
      if (this.props.soa && this.props.soa.hasOwnProperty("productName")) {
        let keyChangedToproductIds = this.props.soa;
        let { productName: productIds, ...rest } = keyChangedToproductIds;
        keyChangedToproductIds = { productIds, ...rest };
        await this.props.setStateParams("soa", keyChangedToproductIds);
      }
      if (this.props?.soa?.initialMethodOfContact === "Other") {
        if (this.props?.soa?.salesChannelOth != "") {
          await this.setState({
            methodOfContactfilled: true,
          });
        } else {
          await this.setState({
            methodOfContactfilled: false,
          });
        }
      }

      //this.props.setStateParams("productIds", this.state.productIds);
      if (
        // (
        //   this.props?.soa?.MA1 === "YES" ||
        //   this.props?.soa?.productIds?.includes("MA1") ||
        //   this.props?.soa?.productIds?.includes("DSNP") ||
        //   this.props?.soa?.productIds?.includes("E005") ||
        //   this.props?.soa?.productIds?.includes("E006") ||
        //   this.props?.soa?.productIds?.includes("PDP1") ||
        //   this.props?.soa?.DSNP === "YES" ||
        //   this.props?.soa?.E005 === "YES" ||
        //   this.props?.soa?.E006 === "YES" ||
        //   this.props?.soa?.PDP1 === "YES") &&
        this.props?.soa?.productIds?.length > 0 &&
        this.props?.soa?.agentName != "" &&
        this.props?.soa?.agentPhone != "" &&
        this.props?.soa?.agentSignutre != "" &&
        this.props?.soa?.repSignature != "" &&
        this.props?.soa?.beneficiaryAddress != "" &&
        this.props?.soa?.beneficiaryName != "" &&
        this.props?.soa?.beneficiaryPhone != "" &&
        this.props?.soa?.dateApntmntCmpltd != "" &&
        this.props?.soa?.initialMethodOfContact != "" &&
        this.props?.soa?.repDate != "" &&
        // this.props?.soa?.repName != "" &&
        // this.props?.soa?.repRelationShip != "" &&
        this.state?.methodOfContactfilled === true
      ) {
        await this.setState({
          isSoaFilled: true,
        });
      } else {
        await this.setState({
          isSoaFilled: false,
        });
      }
      if (this.state?.isSoaFilled === false) {
        await this.setState({
          stepVal: "step0",
        });
      }
    }

    if (this.props.zipCode) {
      let CityListresponse = await this.props.getCityList({
        zipCd: this.props.zipCode,
      });
      if (CityListresponse?.status == "OK") {
        let filteredCity = [];
        if (typeof this.props.countyName === "string") {
          filteredCity = CityListresponse.data.filter(
            (city) => city.countyName.trim() === this.props.countyName?.trim()
          );
        } else {
          filteredCity = CityListresponse.data.filter(
            (city) =>
              city.countyName.trim() ===
              this.props.countyName?.countyName?.trim()
          );
        }
        await this.setState({
          filteredCity: filteredCity,
        });

        if (filteredCity?.length === 1) {
          this.setState({
            ...this.state,
            data: {
              ...this.state.data,
              permanentCity: filteredCity[0].cityName,
            },
          });
        }
      }
    }

    await this.props.getStates();

    let selectedFiles = [];
    let urlList = [];
    let pdfBlobs = [];
    // window.scroll(0, 0);
    window.onbeforeunload = function () {
      //return window.location.href =`${this.props.subDomain}/auth-api/logout?redirectUrl=e-Enroll/login`;
      return "";
    }.bind(this);

    if (Object.keys(this.props.preEnrollInfo).length > 0) {
      if (this.props.preEnrollInfo) {
        await this.props?.setStateParams(
          "electionType",
          this.props.preEnrollInfo?.electionTypeCd
        );
      }
      let enrolledPlan = this.props.cardDetails.filter(
        (product) =>
          product.productId?.trim() ===
          this.props?.preEnrollInfo?.productId?.trim()
      )[0];

      let planSelected = {
        planId: enrolledPlan?.planId,
        pbpId: enrolledPlan?.pbpId,
      };
      this.props.setStateParams("planSelected", planSelected);
      if (this.props.preEnrollInfo?.permanentAddress?.zip4) {
        let isValidpermntZip4 =
          this.props.preEnrollInfo?.permanentAddress?.zip4?.length === 4 ||
          this.props.preEnrollInfo?.permanentAddress?.zip4 === "";
        await this.setState({
          isValidpermntZip4: isValidpermntZip4,
        });
      }
      if (this.props.preEnrollInfo?.mailingAddress?.zip4) {
        let isValidmailZip4 =
          this.props.preEnrollInfo?.mailingAddress?.zip4?.length === 4 ||
          this.props.preEnrollInfo?.mailingAddress?.zip4 === "";
        await this.setState({
          isValidmailZip4: isValidmailZip4,
        });
      }
      if (this.props.preEnrollInfo?.authRepAddress?.zip4) {
        let isValidauthZip4 =
          this.props.preEnrollInfo?.authRepAddress?.zip4?.length === 4 ||
          this.props.preEnrollInfo?.authRepAddress?.zip4 === "";
        await this.setState({
          isValidauthZip4: isValidauthZip4,
        });
      }
      if (
        this.props.preEnrollInfo?.mailingAddress?.zipCode &&
        this.props.preEnrollInfo?.mailingAddress?.zipCode != ""
      ) {
        let mailZip = await this.props.getMailZipCodes(
          this.props.preEnrollInfo?.mailingAddress?.zipCode
        );
        if (mailZip?.data != null) {
          //await this.props.setStateParams("mailingZipCodes", mailZip?.data);
          await this.props.setCampaignProspectStateParams(
            "mailzipCodes",
            mailZip?.data
          );
        } else {
          //await this.props.setStateParams("mailingZipCodes", []);
          await this.props.setCampaignProspectStateParams("mailzipCodes", []);
        }
      }
      let selectedplanproduct = this.props.cardDetails.filter(
        (product) =>
          product.productId?.trim() ===
          this.props?.preEnrollInfo?.productId?.trim()
      )[0]?.productName;
      if (this?.props?.prospectEnroll !== true) {
        this.props.setStateParams("product", selectedplanproduct?.trim());
      }
      let planobj = {};
      if (this.state?.attestationList?.length > 0) {
        const questionDate = this.state.attestationList.filter(
          (data2) => data2.answer != "yes"
        );

        this.setState({
          ...this.state,

          questionDate: questionDate,
        });
      }

      let planId = this.props.preEnrollInfo.planId;
      let type = [
        { attachmentype: "PRE-ENROLLMENT FORM", typeCode: "PEP" },
        { attachmentype: "COORDINATION OF CARE", typeCode: "CC" },
      ];
      selectedFiles = this.props.preEnrollInfo.attachmentList.filter(
        (f) => type.some((s) => s.attachmentype === f.attachmentType) === false
      );
      pdfBlobs = this.props.preEnrollInfo.attachmentList.filter(
        (f) => type.some((s) => s.attachmentype === f.attachmentType) === true
      );
      // urlList = this.props.preEnrollInfo.attachmentList;
      urlList = selectedFiles;
      planobj = PLANS.filter((plan) => plan.planId === planId)[0];
      if (planobj !== undefined && Object.keys(planobj).length > 0) {
        await this.props.setLoginStateParams("selectedPlanId", planId);
        await this.props.setLoginStateParams("selectedPlanName", planobj.name);
      }
    }
    if (
      this.props.year.planYear === "" ||
      this.props.year === "" ||
      this.props.selectedPlan === ""
    ) {
      if (this.props?.agentLogin === true) {
        return (window.location.href = `${this.props.subDomain}/auth-api/logout?redirectUrl=e-Enroll/login`);
      } else {
        return history.push("/e-Enroll/login");
      }
    }

    this.updateAddressFields();

    let state =
      this.props.stateName === ""
        ? this.state.data.permanentState
        : this.props.stateName;
    let county =
      this.props.countyName === ""
        ? this.state.data.permanentCounty
        : this.props.countyName;
    let userCreationEmail =
      this.props.emailAddress === ""
        ? this.state.data.createUserDetails
        : this.props.emailAddress;

    let zip =
      this.props.zipCode !== ""
        ? this.props.zipCode
        : this.state.data.permanentZip;
    await this.props.setStateParams("zip", zip);
    await this.props.setStateParams("state", state);
    await this.props.setStateParams("county", county);
    let pcpName = this.state.data.pcpName;
    let pcpMedicalGroupName = this.state.data.clinicName;
    if (this.props.productName === "Medicare Supplement") {
      pcpName = "P0000000096";
      pcpMedicalGroupName = "WIPRO REES-STEALY MEDICAL GROUP";
    }
    await this.setState((prevState) => ({
      data: {
        ...prevState.data,
        pcpName: pcpName,
        pcpMedicalGroupName: pcpMedicalGroupName,
        permanentState: state,
        permanentCounty: county,
        createUserDetails: userCreationEmail,
        permanentZip: zip,
        permanentCity:
          Object.keys(this.props.preEnrollInfo).length === 0
            ? this.props.cityName
            : this.state.data?.permanentCity,
      },
    }));
    let data1 = this.state.data;
    if (data1) {
      if (
        data1.c1 !== "" ||
        data1.c2 !== "" ||
        data1.c3 !== "" ||
        data1.c4 !== "" ||
        data1.c5 !== "" ||
        data1.c6 !== "" ||
        data1.c7 !== "" ||
        data1.c8 !== "" ||
        data1.c9 !== "" ||
        data1.c10 !== "" ||
        data1.c11 !== "" ||
        data1.c12 !== "" ||
        data1.c13 !== "" ||
        data1.c14 !== "" ||
        data1.c15 !== "" ||
        data1.c16 !== "" ||
        data1.c22 !== "" ||
        data1.aep !== "" ||
        data1.c21 !== "" ||
        data1.c20 !== ""
      ) {
        await this.setState({ disableCheck: true });
      }
    }
    await this.setState({ selectedPlan: this.props.selectedPlan });
    await this.setState({
      ...this.state,
      selectedFiles,
      data: { ...this.state.data, pdfBlobs },
    });
    await this.setState({ urlList });
    if (
      this.state.isInitial === true &&
      Object.keys(this.props.preEnrollInfo).length === 0
    ) {
      this.setState({
        isInitial: false,
        data: { ...this.state.data, ethnicityRace: [] },
      });
    }
    // if (this.props.pendingApplFlag === true) {
    if (Object.keys(this.props.preEnrollInfo).length > 0) {
      this.PhoneNumberFormatter();
    }
    // if (
    //   this.props.preEnrollInfo?.appStatus === "READY" ||
    //   this.props.preEnrollInfo?.appStatus === "SUBMITTED"
    // ) {
    //   await this.props.captchaValidation(true);
    // }
    // if(this?.props?.electionType==="S"){
    //   await this.props?.getsepReasons({productName:this?.props?.product});
    // }
    if (this?.props?.pendingApplFlag === true) {
      await this.props?.getsepReasons({ productName: this?.props?.product });
      if (this.state?.attestationList?.length > 0) {
        await this.setState({
          selectedQnId: [],
        });
        for (let i = 0; i < this.state?.attestationList?.length; i++) {
          await this.setState({
            selectedQnId: this?.state?.selectedQnId.concat(
              this.state?.attestationList[i].qsnMetaId
            ),
          });
        }
        if (this.props?.electionList?.length > 0) {
          if (this?.state?.selectedQnId?.length > 0) {
            let tp = this.props?.electionList.filter(
              (item) => this?.state?.selectedQnId[0] === item.questionId
            )[0]?.value;
            await this.props.setStateParams("electionType", tp ?? "S");
            if (tp === "S" && this?.state?.selectedQnId?.length === 0) {
              if (
                this.props?.sepReasonforS?.length === 0 &&
                this.props?.agentLogin === true
              ) {
                let sepres1 = await this.props?.getsepReasons({
                  productName: this?.props?.product,
                });
                if (sepres1?.status != "OK") {
                  this.setState({
                    ...this.state,
                    snackBarOpen: true,
                    alertMsg:
                      "Some error occurred while fetching data. Please try later",
                    severity: "warning",
                  });
                  return;
                }
              }
            }
          }
        }
      } else {
        await this.props.setStateParams("electionType", "S");

        if (
          this.props?.sepReasonforS?.length === 0 &&
          this.props?.agentLogin === true &&
          this?.state?.selectedQnId?.length === 0
        ) {
          let sepres2 = await this.props?.getsepReasons({
            productName: this?.props?.product,
          });
          if (sepres2?.status != "OK") {
            this.setState({
              ...this.state,
              snackBarOpen: true,
              alertMsg:
                "Some error occurred while fetching data. Please try later",
              severity: "warning",
            });
            return;
          }
        }
        await this.setState({
          selectedQnId: [],
        });
      }
    }
    if (this.state?.attestationList?.length === 0) {
      await this.props.setStateParams("electionType", "S");
      if (
        this.props?.sepReasonforS?.length === 0 &&
        this.props?.agentLogin === true &&
        this.state?.attestationList?.length === 0
      ) {
        let sepres3 = await this.props?.getsepReasons({
          productName: this?.props?.product,
        });
        if (sepres3?.status != "OK") {
          this.setState({
            ...this.state,
            snackBarOpen: true,
            alertMsg:
              "Some error occurred while fetching data. Please try later",
            severity: "warning",
          });
          return;
        }
      }
    }

    //checking user session....
    if (
      !this.props.agentLogin &&
      !this.props.guestLogin &&
      !this.props.beneficiaryLogin
    ) {
      history.push("/e-Enroll/Login");
    }

    if (this.props?.prospectEnroll === true && this.props?.loadApi === false) {
      this.setState({
        ...this.state,
        data: {
          ...this.state.data,
          firstName: this.props?.prospectrowData?.firstName,
          lastName: this.props?.prospectrowData?.lastName,
          middleInitial: this.props?.prospectrowData?.middleInitial,
          birthDate: this.props?.prospectrowData?.dob,
          sex: this.props?.prospectrowData?.gender,
          primaryPhoneNum: this.props?.demographicsData?.homePhone,
          medicareNumber:
            this.props?.prospectrowData?.mbi === null
              ? ""
              : this.props?.prospectrowData?.mbi,
          cellPhoneNum: this.props.demographicsData?.cellPhone,
          permanentCity: this.props.demographicsData?.city,
          emailAddress: this.props.demographicsData?.emailAddress,
          permanentAddrStreet: this.props.demographicsData?.primaryAddress1,
          permanentAddr2: this.props.demographicsData?.primaryAddress2,
          permanentZip4: this.props.demographicsData?.zipPlus4,
        },
      });
    }

    let temp = "";
    let valid = false;
    let value = this.state.data.medicareNumber
      ? this.state.data.medicareNumber
      : "";

    if (value?.length > 0) {
      for (let i = 0; i < value.length; i++) {
        if (i === 1 || i === 4 || i === 7 || i === 8) {
          valid = value.charAt(i).match(/[A-Z]/) ? true : false;
          if (valid === true) {
            valid = !(
              value.charAt(i) === "S" ||
              value.charAt(i) === "L" ||
              value.charAt(i) === "O" ||
              value.charAt(i) === "I" ||
              value.charAt(i) === "B" ||
              value.charAt(i) === "Z"
            );

            if (valid === true) {
              temp = temp + value[i];
              //mandatoryMbi:this.state.mandatoryMbi+value[count]
            }
          }
        }
        if (i === 0 || i === 3 || i === 6 || i === 9 || i === 10) {
          valid = !isNaN(value[i]);

          if (valid === true) {
            //mandatoryMbi:this.state.mandatoryMbi+value[count]
            temp = temp + value[i];
          }
        }
        if (i === 2 || i === 5) {
          valid = value[i].match(/[A-Z]/) ? true : false;
          if (valid === true) {
            valid = !(
              value.charAt(i) === "S" ||
              value.charAt(i) === "L" ||
              value.charAt(i) === "O" ||
              value.charAt(i) === "I" ||
              value.charAt(i) === "B" ||
              value.charAt(i) === "Z"
            );
          }
          valid = !isNaN(value[i]) || valid;
          if (valid === true) {
            //mandatoryMbi:this.state.mandatoryMbi+value[count]
            temp = temp + value[i];
          }
        }
        if (valid === false || valid === null) {
          this.setState({
            snackBarOpen: true,
            alertMsg:
              this.props.lang === "en"
                ? "Please enter mbi in correct format"
                : "Por favor ingrese mbi en el formato correcto",
            severity: "error",
          });
        }
      }

      this.setState({
        mandatoryMbi: temp,
      });
    }
  }

  async componentWillMount() {
    if (!this.props.zipCode) {
      let zipcd = window.sessionStorage.getItem("zipcode");
      if (zipcd) {
        await this.props.setStateParams("zip", zipcd);
        if (!this.props.token) {
          await this.props.setTokenTORedux(
            window.sessionStorage.getItem("token")
          );
        }
        await this.props.getZipCodes(zipcd);
      }
      let selectedPlan = sessionStorage.getItem("selectedPlanDetails");

      await this.props.planSelectionContinue(
        selectedPlan,
        this.props?.customerId
      );
    }
  }
  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onUnload);
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleSteps = async (event) => {
    let value = event.target ? event.target.id : event.id;
    if (value === "step0" && this.state.stepVal !== "step0") {
      await this.setState((prevState) => ({
        ...prevState,
        stepVal: value,
      }));
    } else if (this.state.stepVal === "step0" && value !== "step0") {
      if (this.state.isSoaFilled === false) {
        await this.setState((prevState) => ({
          ...prevState,
          snackBarOpen: true,
          alertMsg:
            "Please fill all the mandatory fields and click on save and next.",
          severity: "error",
          stepVal: "step0",
        }));
      } else {
        await this.setState((prevState) => ({
          ...prevState,
          stepVal: value,
        }));
      }
    } else {
      if (value) {
        await this.setState({ stepVal: value });
      }
    }
  };
  handleDates = (fieldId, dateqnid) => {
    if (fieldId === "partAEffDate" || fieldId === "partBEffDate") {
      DateUtil.getStartDatePickerofMonth("#" + fieldId).datepicker("show");
      DateUtil.getStartDatePickerofMonth("#" + fieldId).on("change", (e) => {
        this.setDates(fieldId, e.target.value, dateqnid);
        DateUtil.getStartDatePickerofMonth("#" + fieldId);
        //.datepicker("refresh");
      });
    } else {
      DateUtil.getDatePicker("#" + fieldId).datepicker("show");
      DateUtil.getDatePicker("#" + fieldId).on("change", (e) => {
        this.setDates(fieldId, e.target.value, dateqnid);
        DateUtil.getDatePicker("#" + fieldId);
        //.datepicker("refresh");
      });
    }
  };
  handleDatesAttestation = (fieldId, currentDateid) => {
    DateUtil.getDatePicker("#" + fieldId).datepicker("show");
    DateUtil.getDatePicker("#" + fieldId).on("change", (e) => {
      this.setDatesAttestation(fieldId, e.target.value, currentDateid);
      DateUtil.getDatePicker("#" + fieldId);
      //.datepicker("refresh");
    });
  };

  qsnsDate = async (currentDateid) => {
    await this.props.setStateParams("currentDateid", currentDateid);
    this.handleDatesAttestation(currentDateid, currentDateid);
  };
  setDatesAttestation = async (fieldId, value, currentDateid) => {
    let dateArray = this.state.questionDate;
    if (dateArray.some((date) => date.qsnMetaId === currentDateid)) {
      let index;
      for (let i = 0; i < dateArray.length; i++) {
        if (dateArray[i].qsnMetaId === currentDateid) {
          index = i;
          break;
        }
      }
      dateArray.splice(index, 1);
    }
    dateArray.push({ qsnMetaId: currentDateid, answer: value });

    let attestationArray = this.state.attestationList.filter(
      (qs) => qs.answer === "yes"
    );

    let finalAttestation = attestationArray.concat(dateArray);
    await this.setState({
      ...this.state,
      attestationList: finalAttestation,
      questionDate: dateArray,
    });
  };
  // CalcNext3months = async () => {
  //   currentYear = new Date().getFullYear();
  //   currentMonth = new Date().getMonth() + 1;
  //   nxtFirstMonth = currentMonth + 1;
  //   nxtSecondMonth = currentMonth + 2;
  //   nxtThirdMonth = currentMonth + 3;
  //   nxtFirstMonthYear = currentYear;
  //   nxtSecondMonthYear = currentYear;
  //   nxtThirdMonthYear = currentYear;
  //   if (nxtFirstMonth > 11) {
  //     nxtFirstMonth = nxtFirstMonth - 12;
  //     nxtFirstMonthYear = currentYear + 1;
  //   }
  //   if (nxtSecondMonth > 11) {
  //     nxtSecondMonth = nxtSecondMonth - 12;
  //     nxtSecondMonthYear = currentYear + 1;
  //   }
  //   if (nxtThirdMonth > 11) {
  //     nxtThirdMonth = nxtThirdMonth - 12;
  //     nxtThirdMonthYear = currentYear + 1;
  //   }
  // };

  setDates = async (fieldId, value, dateqnid) => {
    if (fieldId === "birthDate") {
      if (new Date(value) > new Date()) {
        this.setState({
          ...this.state,
          snackBarOpen: true,
          alertMsg: "Birth date can not be a future date.",
          severity: "error",
          data: { ...this.state.data, [fieldId]: "" },
        });
        return;
      }
    }
    if (fieldId === "beneBirthDate") {
      if (new Date(value) > new Date()) {
        this.setState({
          ...this.state,
          snackBarOpen: true,
          alertMsg: "Birth date can not be a future date.",
          severity: "error",
          data: { ...this.state.data, [fieldId]: "" },
        });
        return;
      }
    }
    if (fieldId === "partAEffDate" || fieldId === "partBEffDate") {
      if (value.split("/")[1] !== "01") {
        if (fieldId === "partAEffDate") {
          this.setState({
            partAvalid: false,
          });
        }
        if (fieldId === "partBEffDate")
          this.setState({
            partBvalid: false,
          });
      } else {
        if (fieldId === "partAEffDate") {
          this.setState({
            partAvalid: true,
          });
        }
        if (fieldId === "partBEffDate")
          this.setState({
            partBvalid: true,
          });
      }
    }
    if (fieldId === "proposedEffDate") {
      let splittedDate = value.split("/");
      if (splittedDate.length === 3) {
        if (splittedDate[2] !== "" && splittedDate[2].length === 4) {
          //this.CalcNext3months();
          // if (
          //   (splittedDate[1].toString() === "01" &&
          //     Number(splittedDate[0]).toString() === nxtFirstMonth.toString() &&
          //     Number(splittedDate[2]).toString() ===
          //       nxtFirstMonthYear.toString()) ||
          //   (Number(splittedDate[0]).toString() === nxtSecondMonth.toString() &&
          //     Number(splittedDate[2]).toString() ===
          //       nxtSecondMonthYear.toString()) ||
          //   (Number(splittedDate[0]).toString() === nxtThirdMonth.toString() &&
          //     Number(splittedDate[2]).toString() ===
          //       nxtThirdMonthYear.toString()) || (Number(splittedDate[0]).toString() === '12' &&
          //       Number(splittedDate[2]).toString() + 1 ===
          //       nxtSecondMonthYear.toString())
          // ) {
          //   this.setState({
          //     proposedvalid: true,
          //   });
          // } else {
          //   this.setState({
          //     proposedvalid: false,
          //   });
          // }

          var dt = new Date();
          var mon = dt.getMonth() + 1;
          var year = dt.getFullYear();
          // var planYear = Number(splittedDate[2]);
          var planYear = Number(this.props.year);
          if (planYear > year) {
            if (
              splittedDate[1].toString() === "01" &&
              (Number(splittedDate[0]) === 1 ||
                Number(splittedDate[0]) === 2) &&
              year + 1 === Number(splittedDate[2])
            ) {
              this.setState({
                proposedvalid: true,
              });
            } else {
              this.setState({
                snackBarOpen: true,
                alertMsg:
                  "Please enter first date of next 3 months of current year.",
                severity: "error",
                proposedvalid: false,
              });
            }
          } else {
            let nxtFirstMonth = mon + 1,
              nxtSecondMonth = mon + 2,
              nxtThirdMonth = mon + 3;
            // let nxtFirstMonthYear=year,nxtSecondMonthYear=year,nxtThirdMonthYear=year
            if (nxtFirstMonth > 11) {
              nxtFirstMonth = nxtFirstMonth - 12;
              //  nxtFirstMonthYear=year+1
            }
            if (nxtSecondMonth > 11) {
              nxtSecondMonth = nxtSecondMonth - 12;
              // nxtSecondMonthYear=year+1
            }
            if (nxtThirdMonth > 11) {
              nxtThirdMonth = nxtThirdMonth - 12;
              // nxtThirdMonthYear=year+1
            }
            if (
              splittedDate[1].toString() === "01" &&
              Number(splittedDate[0]) > mon &&
              ((Number(splittedDate[0]) === nxtFirstMonth &&
                Number(splittedDate[2]) === year) ||
                (Number(splittedDate[0]) === nxtSecondMonth &&
                  Number(splittedDate[2]) === year) ||
                (Number(splittedDate[0]) === nxtThirdMonth &&
                  Number(splittedDate[2]) === year) ||
                (Number(splittedDate[0]) === 12 &&
                  Number(splittedDate[2]) === year))
            ) {
              this.setState({
                proposedvalid: true,
              });
            } else {
              this.setState({
                snackBarOpen: true,
                alertMsg:
                  "Please enter first date of next 3 months of current year.",
                severity: "error",
                proposedvalid: false,
              });
            }
          }
        }
      }
      // let currentYear = new Date().getFullYear();
      // let currentMonth = new Date().getMonth() + 1;
      // if (splittedDate.length === 3) {
      //   if (splittedDate[2] !== "" && splittedDate[2].length === 4) {
      //     if(this?.props?.year===currentYear?.toString()){
      //     if (
      //       Number(splittedDate[1]) > 1 ||
      //       splittedDate[2] != (currentYear) ||
      //       (splittedDate[0] != "" &&
      //         splittedDate[0].length === 2 &&
      //         (currentMonth + 3 < splittedDate[0] ||
      //           splittedDate[0] <= currentMonth))
      //     ) {
      //       this.setState({

      //         proposedvalid: false,

      //       });
      //     } else {
      //       this.setState({
      //         proposedvalid: true,
      //       });
      //     }
      //   }
      //   else{
      //     //selected year is more than current year
      //     if (
      //       (splittedDate[2] != (this?.props?.year)) ||
      //       splittedDate[0] === "" ||
      //         (splittedDate[0]!="01")|| splittedDate[1]!="01"
      //     ) {
      //       this.setState({

      //         proposedvalid: false,

      //       });
      //     } else {
      //       this.setState({
      //         proposedvalid: true,
      //       });
      //     }
      //   }
      //   }
      // }
    }
    await this.setState({ data: { ...this.state.data, [fieldId]: value } });
  };
  handleEffDates = (fieldId) => {
    DateUtil.getStartDatePicker("#" + fieldId)
      .datepicker("show")
      .on("change", (e) => {
        this.setDates(fieldId, e.target.value);
      });
  };
  handleReqEffDates = (fieldId) => {
    DateUtil.getRequEfftDatePicker("#" + fieldId, this?.props?.year).datepicker(
      "show"
    );
    DateUtil.getRequEfftDatePicker("#" + fieldId, this?.props?.year).on(
      "change",
      (e) => {
        this.setDates(fieldId, e.target.value);
        DateUtil.getRequEfftDatePicker("#" + fieldId, this?.props?.year);
        //.datepicker("refresh");
      }
    );
  };
  handleCheckbox2 = async (event) => {
    let name = event.target.name;
    let value = event.target.checked;
    if (name === "mailingAddressRequired") {
      value = event.target.checked ? "YES" : "";
      const {
        permanentAddrStreet,
        permanentAddr2,
        permanentCity,
        permanentZip,
        permanentZip4,
      } = this.state.data;
      // let permanentCounty = this?.props?.MBIDetails?.status==="MATCHED"?this?.state?.data?.permanentCounty:this.props.preEnrollInfo.appNumber
      //   ? this.props.deeplink
      //     ? this.props.dpcountyName
      //     : this.props.preEnrollInfo.permanentAddress.county
      //   : this.props.deeplink
      //   ? this.props.dpcountyName
      //   : this.props?.ZipCodes?.length > 0
      //   ? this.props?.ZipCodes.filter(
      //       (x) => x.stateCd === this.props.stateId
      //     )[0].countyName
      //   : this.props?.ZipCodes[0]?.countyName;

      let permanentCounty =
        this.props?.ZipCodes && this.props.ZipCodes.length > 1
          ? this?.state?.data?.permanentCounty
          : this?.props?.MBIDetails?.status === "MATCHED"
          ? this?.state?.data?.permanentCounty
          : this.props.preEnrollInfo.appNumber
          ? this.props.deeplink
            ? this.props.dpcountyName
            : this.props.preEnrollInfo.permanentAddress.county
          : this.props.deeplink
          ? this.props.dpcountyName
          : this.props?.ZipCodes[0]?.countyName;
      let flag = value === "YES" ? true : false;
      if (flag === true) {
        await this.props.setCampaignProspectStateParams("mailzipCodes", []);
      }
      let mailingAddr = flag ? permanentAddrStreet : "";
      let mailingCity = flag ? permanentCity : "";
      let mailingState = flag ? this.props.stateId : "";
      let mailingzip = flag ? permanentZip : "";
      let mailingAddr2 = flag ? permanentAddr2 : "";
      let mailingZip4 = flag ? permanentZip4 : "";
      let mailingCounty = flag ? permanentCounty : "";
      let mailingCountyCd = flag ? this.props.CountyCd : "";
      await this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          mailingAddr,
          mailingCity,
          mailingState,
          mailingzip,
          mailingAddr2,
          mailingZip4,
          mailingCounty,
          mailingCountyCd,
        },
      });
      return;
    }
    if (name === "languageCheckSpanish") {
      value = event.target.checked ? "true" : "false";
    }

    if (name === "languageCheckOther") {
      value = event.target.checked ? "OTHER" : "";
    }
    await this.setState({
      data: { ...this.state.data, [name]: value },
    });
  };
  // handleMutipleCheckbox = async (event) => {
  //   let name = event.target.name;
  //   let value = event.target.value;
  //   //  let multi=[]
  //   //let multiple=[]
  //   let multiple = this.state?.data?.productName
  //     // ? this.state?.data?.productName
  //     // : [];
  //   if (multiple.includes(value)) {
  //     //let index = multiple.indexOf(value);
  //     //multiple.splice(index, 1);
  //     multiple=multiple.replace(value,"")?.replace(",,",",")
  //     //removing start and end commas 2 if conditions
  //     if(multiple[0]===","){
  //       multiple=multiple.substring(1,multiple.length)
  //     }
  //     if(multiple[multiple.length-1]===","){
  //       multiple=multiple.substring(0,multiple.length-1)
  //     }
  //   } else {
  //     if(multiple?.length>0){
  //     multiple=multiple+","+value;
  //     }
  //     else{
  //       multiple=value
  //     }
  //   }
  //   await this.setState({ data: { ...this.state.data, [name]: multiple } });
  // };
  handleCheckbox = async (event) => {
    let name = event.target.name;
    let value = event.target.checked;
    let save = "";
    if (name === "languageCheckSpanish") {
      value = event.target.checked ? "true" : "false";
    }

    if (name === "aep") {
      value = event.target.checked ? "AEP" : "";
      save = name;
    }
    if (name === "c20") {
      value = event.target.checked ? "OEP" : "";
      save = name;
    }

    if (name === "c21") {
      value = event.target.checked ? "OEPN" : "";
      save = name;
    }
    if (name === "c1") {
      value = event.target.checked ? "NEW" : "";
      save = name;
    }
    if (name === "c2") {
      value = event.target.checked ? "MOV" : "";
      save = name;

      if (value === "") {
        await this.setState({ data: { ...this.state.data, attestation2: "" } });
      }
    }
    if (name === "c3") {
      value = event.target.checked ? "INC" : "";
      save = name;
      if (value === "") {
        await this.setState({ data: { ...this.state.data, attestation3: "" } });
      }
    }
    if (name === "c4") {
      value = event.target.checked ? "RUS" : "";
      save = name;
      if (value === "") {
        await this.setState({ data: { ...this.state.data, attestation4: "" } });
      }
    }
    if (name === "c5") {
      value = event.target.checked ? "LAW" : "";
      save = name;
      if (value === "") {
        await this.setState({ data: { ...this.state.data, attestation5: "" } });
      }
    }
    if (name === "c6") {
      value = event.target.checked ? "MDE" : "";
      save = name;
    }
    if (name === "c8") {
      value = event.target.checked ? "NLS" : "";
      save = name;
      if (value === "") {
        await this.setState({ data: { ...this.state.data, attestation8: "" } });
      }
    }
    if (name === "c9") {
      value = event.target.checked ? "LTC" : "";
      save = name;
      if (value === "") {
        await this.setState({ data: { ...this.state.data, attestation9: "" } });
      }
    }
    if (name === "c10") {
      value = event.target.checked ? "PAC" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, attestation10: "" },
        });
      }
    }
    if (name === "c11") {
      value = event.target.checked ? "LCC" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, attestation11: "" },
        });
      }
    }
    if (name === "c12") {
      value = event.target.checked ? "LEC" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, attestation12: "" },
        });
      }
    }
    if (name === "c13") {
      value = event.target.checked ? "PAP" : "";
      save = name;
    }
    if (name === "c14") {
      value = event.target.checked ? "EOC" : "";
      save = name;
    }
    if (name === "c15") {
      value = event.target.checked ? "SNP" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, attestation15: "" },
        });
      }
    }
    if (name === "c22") {
      value = event.target.checked ? "MCD" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, recentlyChangeMedicaid: "" },
        });
      }
    }
    if (name === "c23") {
      value = event.target.checked ? "HLP" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, attestation23: "" },
        });
      }
    }
    if (name === "c25") {
      value = event.target.checked ? "DST" : "";
      save = name;
    }
    if (name === "c7") {
      value = event.target.checked ? "HLP" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, attestation7: "" },
        });
      }
    }
    if (name === "c16") {
      value = event.target.checked ? "OTH" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, c16Attestation: "", attestation16: "" },
        });
      }
    }

    await this.setState({
      data: { ...this.state.data, [name]: value },
      checkName: save,
    });

    if (value === "") {
      await this.setState({ disableCheck: false });
    } else {
      await this.setState({ disableCheck: true });
    }
  };

  submitData = async () => {
    const payload2 = this.getData(this.state);
    if (
      this.props?.agentLogin === true &&
      this?.props?.electionType === "S" &&
      (this.state?.data?.sepReasonCd?.trim() === "" ||
        this.state?.data?.sepReasonCd === null ||
        this.state?.data?.sepReasonCd === undefined)
    ) {
      this.setState({
        snackBarOpen: true,
        alertMsg:
          this.props.lang === "es"
            ? "Por favor complete el motivo de la elección tipo S"
            : "Please fill sep reason for election type S",
        severity: "error",
      });
      return;
    }
    this.MailingandAuthCheck();
    if (this.AuthAddressFilled === true) {
      if (this.mailingAddressFilled === true) {
        ReactGA.event({
          category: "Button",
          action: "Form Submission",
        });
        let paperEnrollFileUploadCheck =
          this.state?.selectedFiles.some(
            (obj) => obj?.name == "PAPER ENROLLMENT"
          ) ||
          this.state?.selectedFiles.some(
            (obj) => obj?.attachmentType == "PAPER ENROLLMENT"
          );
        if (
          this.state?.data?.applcat == "E-ENROLL PAPER" &&
          paperEnrollFileUploadCheck === false
        ) {
          this.setState({
            snackBarOpen: true,
            alertMsg:
              this.props.lang === "es"
                ? "Cargue el archivo de solicitud de inscripción en papel"
                : "Please upload paper enrollment application file",
            severity: "error",
          });
          return;
        }
        // if (this.state.data.mailingAddressRequired !== "YES") {
        //   await this.setState({
        //     data: { ...this.state.data, mailingState: "" },
        //   });
        // }
        let emailFlag =
          this.state.data.emailAddress !== ""
            ? this.validator.check(this.state.data.emailAddress, "email") !==
              false
              ? true
              : false
            : true;
        let cardioValidator =
          this.props.customerId !== VERDA_CONSTS.ID
            ? true
            : this.props.productId === "TX2B" ||
              this.props.data?.productId === "TX2B"
            ? this.state.data.cardioVascular === "Y"
            : true;
        let cordinationValidator =
          this.props.customerId !== VERDA_CONSTS.ID
            ? true
            : this.state.data.careInd === "Y";
        if (!cardioValidator) {
          this.setState({
            snackBarOpen: true,
            alertMsg:
              this.props.lang === "es"
                ? 'Seleccione "Sí" y complete el formulario de evaluación de preinscripción antes de enviar la solicitud en caso de que tenga un trastorno cardiovascular, insuficiencia cardíaca congestiva o diabetes.'
                : 'Please select "Yes" and fill Pre-enrollment assessment form before application submission in case you have Cardiovascular disorder, CHF and or Diabetes.',
            severity: "error",
          });
          return;
        }
        if (!cordinationValidator) {
          this.setState({
            snackBarOpen: true,
            alertMsg:
              this.props.lang === "es"
                ? 'Seleccione "Sí" para la continuidad de la atención y complete el formulario de coordinación de la atención antes de enviar la solicitud.'
                : 'Please select "Yes" for continuity of care and fill coordination of care form before application submission.',
            severity: "error",
          });
          return;
        }
        if (
          this.state?.isValidauthZip4 === true &&
          this.state?.isValidpermntZip4 === true &&
          this.state?.isValidmailZip4 === true
        ) {
          if (emailFlag) {
            this.props.setStateParams(
              "attachmentList",
              this.props?.preEnrollInfo?.attachmentList
            );
            const response = await this.props.submitForm(payload2);
            this.props.setSpinner(true);
            if (response.message === "SUCCESS") {
              this.props.setStateParams("Submitted", true);
              const { selectedFiles } = this.state;
              if (this.props.pendingApplFlag) {
                let address1 = this.state.data?.pcpDetails;
                if (address1 === undefined) {
                  address1 = {};
                }
                if (this.props.pcpSelected?.pcpAddress === undefined) {
                  Object.assign(address1, {
                    pcpAddress: this.state.data?.pcpDetails?.address,
                  });
                  this.props.setStateParams("selectedVo", address1);
                }
              }
              await this.props.setSpinner(true);

              let pdfData = Object.assign(payload2, {
                permanentCnt: this.state.data.permanentCounty?.countyName
                  ? this.state.data.permanentCounty.countyName
                  : this.state.data.permanentCounty,
              });
              pdfData = Object.assign(pdfData, {
                questionDate: this.state.data.questionDate,
              });
              pdfData.pcpAddr = this.props.pcpSelected?.pcpAddress;
              pdfData.qsns = this.props.qsns;
              pdfData.agentSign = this.state.data?.agentSign;
              if (this.state.data.relationOfRep !== "") {
                pdfData.authReln = this.props.authorizedrelations.filter(
                  (r) => r.value === this.state.data.relationOfRep
                )[0]?.label;
              } else {
                pdfData.authReln = "";
              }
              // pdfData=Object.assign(pdfData,{pcpAddr:pcpAddr})
              this.props.setStateParams("pdfData", pdfData);
              this.props.setStateParams("pcpDetails", {});
              if (
                this.props.agentLogin === true &&
                [VERDA_CONSTS.ID, NEBRASKA_CONSTS.ID, ILS_CONSTS.ID].every(
                  (id) => id !== this.props?.customerId
                )
              ) {
                const formData1 = new FormData();
                const blob2 = await pdf(
                  <SoaDocument
                    customerId={this.props?.customerId}
                    pdfData={this.state.SOA}
                    flag={true}
                  />
                ).toBlob();

                var file1 = new File([blob2], "soa.pdf", {
                  type: "application/pdf",
                  lastModified: new Date().getTime(),
                });
                formData1.append("attachment", file1);
                formData1.append("customerId", this.props?.customerId);
                formData1.append("appNumber", response.data);
                formData1.append("attachmentType", "SOA");
                formData1.append("emailAddress", "");
                await this.props.uploadFile(formData1);
              }
              await this.props.setSpinner(true);
              const formData = new FormData();

              let addr =
                this.props.agentLogin === true
                  ? this.props.agentEmailId
                  : this.props.emailAddress;
              let ptFlag = false;
              ptFlag = addr?.toLowerCase().includes("ptuser");
              if (
                [VERDA_CONSTS.ID, NEBRASKA_CONSTS.ID, ILS_CONSTS.ID].every(
                  (id) => id !== this.props?.customerId
                )
              ) {
                const blob1 = await pdf(
                  <ConfPdf
                    pdfData={pdfData}
                    selectedVo={this.props.pcpSelected}
                    attachment={this.props?.attachmentListpdf}
                  />
                ).toBlob();
                var file = new File([blob1], "Confirmation.pdf", {
                  type: "application/pdf",
                  lastModified: new Date().getTime(),
                });
                formData.append("attachment", file);
                formData.append("customerId", this.props?.customerId);
                formData.append("appNumber", response.data);
                formData.append("attachmentType", "ENRL");
                formData.append(
                  "emailAddress",
                  this.props?.dpemail
                    ? this.props.dpemail
                    : ptFlag === true
                    ? ""
                    : addr
                );
                await this.props.uploadFile(formData);
              }
              let c = 0;
              let n = 0;
              let newcount = 0;
              await this.props.setSpinner(true);
              for (let i = 0; i < this.state.selectedFiles.length; i++) {
                // Update the formData object
                if (this.state.selectedFiles[i].name !== undefined) {
                  c = c + 1;
                }
              }
              if (selectedFiles.length || this.state.data.agentSign) {
                if (this.state.data.agentSign) {
                  const sig = await this.props.uploadSign({
                    attachmentType: "SIGN",
                    signature: this.state.data.agentSign,
                    customerId: this.props?.customerId,
                    appNumber: response.data,
                  });
                  if (sig.message !== "SUCCESS") {
                    this.setState({
                      snackBarOpen: true,
                      alertMsg:
                        this.props.lang === "es"
                          ? "Error del sistema."
                          : "System Error.",
                      severity: "error",
                    });
                    return;
                  }
                }

                if (selectedFiles.length) {
                  const { preEnrollInfo, uploadedFilesInPreEnroll } =
                    this.props;
                  let prevSelectedFiles =
                    preEnrollInfo?.attachmentList &&
                    preEnrollInfo?.attachmentList?.length > 0
                      ? [
                          ...preEnrollInfo.attachmentList.map(
                            (list) => list.attachmentName
                          ),
                          ...uploadedFilesInPreEnroll,
                        ]
                      : uploadedFilesInPreEnroll;
                  for (const selectedFile of this.state.selectedFiles) {
                    if (
                      selectedFile?.File?.name != undefined &&
                      !prevSelectedFiles.includes(selectedFile?.File?.name)
                    ) {
                      newcount = newcount + 1;
                      const formData2 = new FormData();

                      // Update the formData object
                      if (selectedFile.name !== undefined) {
                        const selectedIndex =
                          this?.props?.typeOfFilesToUpload?.findIndex(
                            (type) => type.attachmentDesc === selectedFile.name
                          );

                        formData2.append(
                          "attachment",
                          selectedFile.File,
                          selectedFile.File.name
                        );
                        formData2.append("appNumber", response.data);
                        formData2.append(
                          "attachmentType",
                          this?.props?.typeOfFilesToUpload[selectedIndex]
                            ?.attachmentType
                        );
                        formData2.append("customerId", this.props?.customerId);
                        const resp = await this.props.uploadFile(formData2);

                        if (resp?.message === "SUCCESS") {
                          n = n + 1;
                        }
                      }
                    }
                  }
                }
              }
              this.verdaPdfUpload(response);
              if (newcount != 0) {
                if (n === c) {
                  await this.props.setSpinner(false);
                  history.push("/e-Enroll/Confirmation");
                } else {
                  this.setState({
                    snackBarOpen: true,
                    alertMsg:
                      this.props.lang === "es"
                        ? "Error del sistema."
                        : "System Error.",
                    severity: "error",
                  });
                  return;
                }
              } else {
                await this.props.setSpinner(false);
                history.push("/e-Enroll/Confirmation");
              }
            } else {
              this.setState({
                snackBarOpen: true,
                alertMsg:
                  this.props.lang === "es"
                    ? "Envío fallido"
                    : "Submission Failed",
                severity: "error",
              });
            }
          } else {
            this.setState({
              snackBarOpen: true,
              alertMsg:
                this.props.lang === "es"
                  ? "Por favor ingrese una dirección de correo electrónico válida"
                  : "Please Enter valid Email address",
              severity: "error",
            });
          }
        } else {
          this.setState({
            snackBarOpen: true,
            alertMsg:
              this.props.lang === "es"
                ? "¡Ingrese un Zip4 válido!"
                : "Please Enter valid Zip4!",
            severity: "error",
          });
        }
      } else {
        this.setState({
          snackBarOpen: true,
          alertMsg:
            this.props.lang === "es"
              ? "Ingrese todos los campos para la dirección postal"
              : "Please enter all the fields for mailing address ",
          severity: "error",
        });
        return;
      }
    } else {
      this.setState({
        snackBarOpen: true,
        alertMsg:
          this.props.lang === "es"
            ? "Ingrese todos los campos para la dirección del representante autorizado"
            : "Please enter all the fields for authorized representative address ",
        severity: "error",
      });
      return;
    }
  };
  getData = (stateObj) => {
    let attestqsns = stateObj.attestationList;
    let productinSoa = "";

    // for (const key in this.props.productIds) {
    //   if (this.props.productIds[key] == "YES") {
    //     productinSoa = productinSoa + key + ",";
    //   }
    // }
    const clinicfilter =
      this.props.physiciansData.length > 1
        ? this.props.physiciansData.filter(
            (data1) =>
              (data1.doctorName &&
                this.props.pcpSelected?.pcpName &&
                data1.doctorName === this.props.pcpSelected?.pcpName) ||
              (data1.doctorName &&
                this.props.preEnrollInfo?.pcpName &&
                data1.doctorName === this.props.preEnrollInfo?.pcpName)
          )[0] !== undefined
          ? this.props.physiciansData.filter(
              (data1) =>
                (data1.doctorName &&
                  this.props.pcpSelected?.pcpName &&
                  data1.doctorName === this.props.pcpSelected?.pcpName) ||
                (data1.doctorName &&
                  this.props.preEnrollInfo?.pcpName &&
                  data1.doctorName === this.props.preEnrollInfo?.pcpName)
            )[0].clinicName
          : this.props?.preEnrollInfo?.clinicName
          ? this.props.preEnrollInfo.clinicName
          : ""
        : "";
    const { pendingApplFlag } = this.props;
    const data2 = {
      customerId: this.props?.customerId,
      planYear: this.props?.year,
      appStatus: "",
      sepReasonCd:
        this.props?.agentLogin === true
          ? this?.props?.electionType
            ? this?.props?.electionType === "S"
              ? this.state?.data?.sepReasonCd.split("-")[0]
              : ""
            : ""
          : "",
      electionTypeCd:
        this.props?.agentLogin === true
          ? this?.props?.electionType
            ? this?.props?.electionType
            : ""
          : "",
      prspctLeadNbr: this.props?.leadIdNbrpayload
        ? this.props?.leadIdNbrpayload
        : this.props?.preEnrollInfo?.prspctLeadNbr,
      appNumber: pendingApplFlag
        ? this.props?.appNum
        : this.props.guestbeneagentAppNum
        ? this.props.guestbeneagentAppNum
        : this.props.count
        ? this.props.count
        : null,

      // planName: this.props.preEnrollInfo.planName
      //   ? this.props.preEnrollInfo.planName
      //   : pendingApplFlag
      //   ? stateObj?.data?.planName
      //     ? stateObj?.data?.planName
      //     : this.props.planName
      //   : this.props.planName,
      planName: this.props.planName
        ? this.props.planName
        : this.props.preEnrollInfo?.planName,
      productId:
        // this.props.deeplink
        //   ? this.props.dpProductId
        stateObj.data?.productId
          ? stateObj.data?.productId
          : this.props.productId,
      premimumAmount: this.props.premiumAmount ? this.props.premiumAmount : 0,
      prefix: stateObj.data.prefix,
      firstName: stateObj.data.firstName,
      lastName: stateObj.data.lastName,
      middleInitial: stateObj.data.middleInitial,
      birthDate: stateObj.data.birthDate,
      sex: stateObj.data?.sex ? stateObj.data?.sex : "",
      primaryPhoneNum:
        stateObj.data.primaryPhoneNum != null &&
        stateObj.data.primaryPhoneNum != undefined &&
        stateObj.data.primaryPhoneNum != ""
          ? stateObj.data.primaryPhoneNum.replace(/[^0-9]/g, "").slice(0, 10)
          : "",
      cellPhoneNum:
        stateObj.data.cellPhoneNum != null &&
        stateObj.data.cellPhoneNum != undefined &&
        stateObj.data.cellPhoneNum != ""
          ? stateObj.data.cellPhoneNum.replace(/[^0-9]/g, "").slice(0, 10)
          : "",
      proposedEffDate: stateObj.data?.proposedEffDate,
      medicareNumber: stateObj?.data?.medicareNumber
        ? stateObj.data.medicareNumber?.slice(0, 11)
        : "",
      isDrugCoverage: stateObj.data.isDrugCoverage,
      nameOfCoverage: stateObj.data.nameOfCoverage,
      covMemberNumber: stateObj.data.covMemberNumber,
      covGroupNumber: stateObj.data.covGroupNumber,
      lastNameOfRep: stateObj.data?.lastNameOfRep,
      middleNameOfRep: stateObj.data?.middleNameOfRep,
      isAuthRepresentative: stateObj.data.isAuthRepresentative,
      nameOfRep: stateObj.data.nameOfRep,
      relationOfRep: stateObj.data.relationOfRep,
      phoneNumberOfRep: stateObj.data.phoneNumberOfRep
        ? stateObj.data.phoneNumberOfRep
            .replace("(", "")
            .replace(")", "")
            .replace("-", "")
            .replace(" ", "")
        : "",
      isLicensedSalesRep: stateObj.data.isLicensedSalesRep,
      salRepName: this.props?.soa?.agentName?.split("-")[1]?this.props?.soa?.agentName?.split("-")[1]:stateObj.data.salRepName,
      salRepLicenseNumber: this.props?.soa?.agentName?.split("-")[0]?this.props?.soa?.agentName?.split("-")[0]:stateObj.data.salRepLicenseNumber,
      accessibleFormatVal: stateObj?.data?.accessibleFormatVal?.replace(
        "_",
        ""
      ),
      pcpName: this.props.pcpSelected.pcpName
        ? this.props.pcpSelected.pcpName
        : this.props?.preEnrollInfo?.pcpName
        ? this.props.preEnrollInfo.pcpName
        : "",
      pcpAddress: this.props.pcpSelected.pcpAddress
        ? this.props.pcpSelected.pcpAddress
        : this.props?.preEnrollInfo?.pcpAddress
        ? this.props.preEnrollInfo.pcpAddress
        : "",
      clinicName: clinicfilter
        ? clinicfilter
        : this.props.preEnrollInfo.clinicName
        ? this.props.preEnrollInfo.clinicName
        : "",
      emailAddress: stateObj.data.emailAddress,
      emailOptionIndicator: stateObj.data.emailOptionIndicator,
      isCurrentPatient: stateObj.data.isCurrentPatient,
      isSpouseWork: stateObj.data.isSpouseWork,
      doYouWork: stateObj.data.doYouWork,
      attachmentList: [],
      authRepAddress: {
        streetAddress: stateObj.data?.addressOfRep
          ? stateObj.data.addressOfRep
          : "",
        address2: stateObj.data?.addressOfRep2
          ? stateObj.data?.addressOfRep2
          : "",
        address3: stateObj.data?.address3 ? stateObj.data?.address3 : "",
        city: stateObj.data?.authRepCity ? stateObj.data?.authRepCity : "",
        state: stateObj.data?.authRepState ? stateObj.data?.authRepState : "",
        zipCode: stateObj.data?.authRepZip ? stateObj.data?.authRepZip : "",
        zip4: stateObj.data.authZip4,
      },
      permanentAddress: {
        streetAddress: stateObj.data.permanentAddrStreet,
        address2: stateObj?.data?.permanentAddr2,
        city: stateObj.data.permanentCity?.slice(0, 20),
        county: stateObj.data.permanentCounty
          ? stateObj.data.permanentCounty.countyName
            ? stateObj.data.permanentCounty.countyName?.slice(0, 3)
            : stateObj.data.permanentCounty?.slice(0, 3)
          : "",
        state: this.props.stateId,
        zipCode: stateObj.data.permanentZip,
        zip4: stateObj.data.permanentZip4,
        countyCd: this.props.CountyCd,
      },
      mailingAddress: {
        streetAddress: stateObj.data.mailingAddr,
        address2: stateObj?.data.mailingAddr2,
        city: stateObj.data.mailingCity?.slice(0, 20),
        county: stateObj?.data.mailingCounty?.slice(0, 3),
        state: stateObj.data.mailingState?.slice(0, 2),
        zipCode: stateObj.data.mailingzip,
        zip4: stateObj.data.mailingZip4,
        countyCd: stateObj?.data.mailingCounty
          ? stateObj.data.mailingCountyCd
          : "",
      },
      attestationList: attestqsns,
      soaDetails: this.props.agentId
        ? {
            salesChannelOth:
              this.props.soa?.initialMethodOfContact === "Other"
                ? this.props?.soa?.salesChannelOth
                : "",
            productIds: this.props.soa?.productIds
              ? this.props.soa?.productIds
              : "",
            repName: this.props.soa?.repName ? this.props.soa.repName : "",
            repRelationShip: this.props.soa?.repRelationShip
              ? this.props.soa?.repRelationShip?.slice(0, 20)
              : "",
            repSignature: this.props.soa?.repSignature
              ? this.props.soa?.repSignature
              : "",
            repDate: this.props.soa?.repDate ? this.props.soa?.repDate : "",
            agentId: this.props.agentId ? this.props.agentId : null,
            agentName: this.props.soa?.agentName
              ? this.props.soa?.agentName
              : "",
            agentPhone: this.props.soa?.agentPhone
              ? this.props.customerId === ILS_CONSTS.ID
                ? this.props.soa?.agentPhone
                : this.props.soa?.agentPhone
                    .replace("(", "")
                    .replace(")", "")
                    .replace("-", "")
                    .replace(" ", "")
              : "",
            agentSignutre: this.props.soa?.agentSignutre
              ? this.props.soa?.agentSignutre
              : "",
            dateApntmntCmpltd: this.props.soa?.dateApntmntCmpltd
              ? this.props.soa?.dateApntmntCmpltd
              : "",
            beneficiaryName: this.props.soa?.beneficiaryName
              ? this.props.soa?.beneficiaryName
              : "",
            beneficiaryPhone: this.props.soa?.beneficiaryPhone
              ? this.props.soa?.beneficiaryPhone
                  .replace("(", "")
                  .replace(")", "")
                  .replace("-", "")
                  .replace(" ", "")
              : "",
            beneficiaryAddress: this.props.soa?.beneficiaryAddress
              ? this.props.soa?.beneficiaryAddress
              : "",
            initialMethodOfContact: this.props.soa?.initialMethodOfContact
              ? this.props.soa?.initialMethodOfContact?.slice(0, 6)
              : "",
            agentSignDate: this.props.soa?.agentSignDate ?? "",
            beneBirthDate: this.props.soa?.beneBirthDate,
            medicaidId: this.props.soa?.medicaidId,
            beneficiaryInitial: this.props.soa?.beneficiaryInitial ?? "",
          }
        : null,
      prefLng: stateObj.data.prefLng ?? "",
      todayDate: new Date()
        .toLocaleString("en-US", {
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        })
        .split(",")[0],
      name: stateObj.data.name,
      signature: stateObj.data.name,
      isSigned: stateObj.data.agentSign || stateObj.data.name ? "Y" : "N",
      officeCd: this.props.pcpSelected.pcpOfficeCd
        ? this.props.pcpSelected.pcpOfficeCd
        : this.props?.preEnrollInfo?.officeCd
        ? this.props.preEnrollInfo.officeCd
        : "",
      locationId: this.props.pcpSelected.PcpLocationId
        ? this.props.pcpSelected.PcpLocationId
        : this.props?.preEnrollInfo?.locationId
        ? this.props?.preEnrollInfo?.locationId
        : "",
      proposedEffDate:
        moment(stateObj.data?.proposedEffDate, "MM/DD/YYYY", true).isValid() &&
        stateObj?.proposedvalid === true
          ? stateObj.data?.proposedEffDate
          : "",
      partAEffDate:
        moment(stateObj.data.partAEffDate, "MM/DD/YYYY", true).isValid() &&
        stateObj?.partAvalid === true
          ? stateObj.data.partAEffDate
          : "",
      partBEffDate:
        moment(stateObj.data.partBEffDate, "MM/DD/YYYY", true).isValid() &&
        stateObj?.partBvalid === true
          ? stateObj.data.partBEffDate
          : "",
      ethnicityRace: stateObj.data.ethnicityRace,
      premiumType:
        stateObj.data?.premiumType == "A"
          ? stateObj.data?.monthlybenefitsfrom != "" &&
            stateObj.data?.monthlybenefitsfrom != undefined &&
            stateObj.data?.monthlybenefitsfrom != null
            ? stateObj.data?.monthlybenefitsfrom
            : stateObj?.data?.premiumType
          : stateObj.data?.premiumType,
      //below four fields are related to nebraska,ils
      acctholdername: stateObj.data.acctholdername,
      routingNumber: stateObj.data.routingNumber,
      accountNumber: stateObj.data.accountNumber,
      bankName: stateObj.data?.bankName ?? "",
      acctType: stateObj.data.acctType,
      esrdInd: stateObj.data?.esrdInd,
      medicaidInd: stateObj.data.medicaidInd,
      medicaidId: stateObj.data.medicaidId?.slice(0, 20),
      //monthlybenefitsfrom: this.state.data?.monthlybenefitsfrom,
      termsAndConditions: stateObj.data?.termsAndConditions,
      applcat: stateObj?.data?.applcat ? stateObj?.data?.applcat : "",
      // stateObj.data.applcat === "E-ENROLL AGENT"
      //   ? "E-ENROLL AGENT"
      //   : stateObj.data.applcat === "E-ENROLL TELEPHONE"
      //   ? "E-ENROLL TELEPHONE"
      //   : "",
      ltcInd: stateObj.data?.ltcInd,
      nameOfInstitution: stateObj.data?.nameOfInstitution?.slice(0, 50),
      addrOfInstitution: stateObj.data?.addrOfInstitution?.slice(0, 50),
      agentId: this.props.agentId != undefined ? this.props.agentId : "",
      agencyId: this.props?.agencyIDSelected,
      language: this.props.lang,
      cardioVascular: stateObj.data?.cardioVascular,
      careInd: stateObj.data?.careInd,
      agentSign: stateObj.data?.agentSign ?? "",
      //below are some nebraska fields
      // agentFirstName: this.props.firstName,
      // agentLastName: this.props.lastName,
      // agentEmail: stateObj.data?.agentEmail ?? "",
      // agentTax: this.props.agentTaxId,
      agentDetails: {
        agentEmail: this.props.agentEmailId,
        agentTaxId: this.props.agentTaxId,
        firstName: this.props.firstName,
        lastName: this.props.lastName,
      },
      planId: this.props?.planSelecteddetails?.planId,
      //above are some nebraska fields
      attestationOther: stateObj.data?.attestationOther ?? "", // this belongs to ILS only , attestation other text box
      textIndicator: stateObj.data?.textIndicator ?? "", // this belongs to ILS only , related to email option indicator
      attestationMajorDisaster: stateObj.data?.attestationMajorDisaster ?? "", // this belongs to verda , attestation question section
      attestationElectionMissed: stateObj.data?.attestationElectionMissed ?? "", // this belongs to verda , attestation question section
      prefLngOthrValue: stateObj.data?.prefLngOthrValue ?? "", // for ILS only
    };
    return data2;
  };
  base64ToBlob = (base64) => {
    const binaryString = window.atob(base64);

    const len = binaryString.length;

    const bytes = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return new Blob([bytes], { type: "application/octet-stream" });
  };
  verdaPdfUpload = async (response) => {
    this.state.data.pdfBlobs.forEach(async (verdaFile, index) => {
      const formData = new FormData();
      // const binaryString=window.atob(verdaFile.attachment.split(",")[1])
      // const blob=new Blob([binaryString],{type:"application/pdf"})
      if (verdaFile?.attachment) {
        const blob = this.base64ToBlob(verdaFile.attachment?.split(",")[1]);
        let file = new File([blob], `${verdaFile.attachmentType}.pdf`, {
          type: "application/pdf",
          lastModified: new Date().getTime(),
        });
        formData.append("attachment", file);
        formData.append("appNumber", response.data);
        formData.append("attachmentType", verdaFile.typeCode);
        formData.append("customerId", this.props?.customerId);

        if (
          verdaFile.typeCode !== undefined &&
          !this.verdaFilesUploaded.includes(verdaFile.typeCode)
        ) {
          // if(!this.verdaFilesUploaded.includes(verdaFile.typeCode)){
          const resp = await this.props.uploadFile(formData);
          if (resp.status === "OK") {
            this.verdaFilesUploaded.push(verdaFile.typeCode);
          }
        }
      }
    });
  };
  saveData = async () => {
    const payload2 = this.getData(this.state);
    this.MailingandAuthCheck();
    if (this.AuthAddressFilled === true) {
      if (this.mailingAddressFilled === true) {
        const response = await this.props.saveLogout(payload2);
        if (response.message === "SUCCESS") {
          const { selectedFiles } = this.state; // File, FileName,
          if (
            this.props.agentLogin === true &&
            [VERDA_CONSTS.ID, NEBRASKA_CONSTS.ID, ILS_CONSTS.ID].every(
              (ids) => ids !== this.props?.customerId
            )
          ) {
            this.props.setSpinner(true);
            const formData = new FormData();
            const blob1 = await pdf(
              <SoaDocument
                customerId={this.props?.customerId}
                pdfData={this.state.SOA}
                flag={true}
              />
            ).toBlob();
            var file = new File([blob1], "soa.pdf", {
              type: "application/pdf",
              lastModified: new Date().getTime(),
            });
            formData.append("attachment", file);
            formData.append("customerId", this.props?.customerId);
            formData.append("appNumber", response.data);
            formData.append("attachmentType", "SOA");
            formData.append("emailAddress", "");
            await this.props.uploadFile(formData);
          }
          if (this.state.data.agentSign) {
            const sig = await this.props.uploadSign({
              attachmentType: "SIGN",
              signature: this.state.data.agentSign,
              customerId: this.props?.customerId,
              appNumber: response.data,
            });
            if (sig.message !== "SUCCESS") {
              this.setState({
                snackBarOpen: true,
                alertMsg:
                  this.props.lang === "es"
                    ? "Error del sistema."
                    : "System Error.",
                severity: "error",
              });
              return;
            }
          }
          if (!selectedFiles.length) {
            await this.verdaPdfUpload(response);
            if (
              this.props.isAgentRole === true ||
              this.props.isSuperUser === true
            ) {
              this.setState({
                snackBarOpen: true,
                alertMsg:
                  "Application Id : " +
                  response?.data +
                  ", saved Successfully!",
                severity: "success",
                ethnicityRace: [],
              });
              window.location.href = `${this.props.subDomain}/auth-api/logout?redirectUrl=e-Enroll/login`;

              // setTimeout(() => {
              //   history.push("/e-Enroll/login");
              // }, 2000);
              // this.props.setStateParams("selectedVo", {});
              // this.props.setStateParams("pcpDetails", {});
              return;
            } else {
              this.setState({
                snackBarOpen: true,
                alertMsg:
                  "Application Id : " +
                  response?.data +
                  ", saved Successfully!",
                severity: "success",
                ethnicityRace: [],
              });
              //changedlogout setTimeout(() => {
              //   history.push("/e-Enroll/login");
              // }, 2000);
              if (this.props?.agentLogin === true) {
                window.location.href = `${this.props.subDomain}/auth-api/logout?redirectUrl=e-Enroll/login`;
              } else {
                setTimeout(() => {
                  history.push("/e-Enroll/login");
                }, 2000);
              }
            }
            return;
          }
          const { preEnrollInfo, uploadedFilesInPreEnroll } = this.props;
          let prevSelectedFiles =
            preEnrollInfo?.attachmentList &&
            preEnrollInfo?.attachmentList?.length > 0
              ? [
                  ...preEnrollInfo.attachmentList.map(
                    (list) => list.attachmentName
                  ),
                  ...uploadedFilesInPreEnroll,
                ]
              : uploadedFilesInPreEnroll;
          for (const selectedFile of this.state.selectedFiles) {
            if (!prevSelectedFiles.includes(selectedFile?.File?.name)) {
              const formData = new FormData();

              // Update the formData object
              if (selectedFile.name !== undefined) {
                const selectedIndex =
                  this?.props?.typeOfFilesToUpload.findIndex(
                    (type) => type.attachmentDesc === selectedFile.name
                  );
                formData.append(
                  "attachment",
                  selectedFile.File,
                  selectedFile.File.name
                );
                formData.append("appNumber", response.data);
                formData.append(
                  "attachmentType",
                  this?.props?.typeOfFilesToUpload[selectedIndex]
                    ?.attachmentType
                );
                formData.append("customerId", this.props?.customerId);
                await this.props.uploadFile(formData);
              }
            }
          }
          await this.verdaPdfUpload(response);
          let index = response.data.indexOf("=") + 1;
          let id = response.data.slice(index, response.data.length);
          await this.props.removeplan();
          this.setState({
            snackBarOpen: true,
            alertMsg: "Application Id : " + id + ", saved Successfully!",
            severity: "success",
            ethnicityRace: [],
          });
          if (
            this.props.isAgentRole === true ||
            this.props.isSuperUser === true
          ) {
            window.location.href = `${this.props.subDomain}/auth-api/logout?redirectUrl=e-Enroll/login`;
            // setTimeout(() => {
            //   history.push("/e-Enroll/login");
            // }, 2000);
            // this.props.setStateParams("selectedVo", {});
            // this.props.setStateParams("pcpDetails", {});
            return;
          } else {
            setTimeout(() => {
              history.push("/e-Enroll/login");
            }, 2000);
          }
        } else {
          let msg =
            this.props.lang === "es" ? "Guardar fallida" : "Save Failed";
          this.setState({
            snackBarOpen: true,
            alertMsg: msg,
            severity: "error",
          });
        }
        this.props.LogoutToken();
        // this.props.setStateParams("selectedVo", {});
        // this.props.setStateParams("pcpDetails", {});
      } else {
        this.setState({
          snackBarOpen: true,
          alertMsg:
            this.props.lang === "es"
              ? "Ingrese todos los campos para la dirección postal"
              : "Please enter all the fields for mailing address ",
          severity: "error",
        });
        return;
      }
    } else {
      this.setState({
        snackBarOpen: true,
        alertMsg:
          this.props.lang === "es"
            ? "Ingrese todos los campos para la dirección del representante autorizado"
            : "Please enter all the fields for authorized representative address ",
        severity: "error",
      });
      return;
    }
  };

  MailingandAuthCheck = async () => {
    const {
      mailingAddr,
      mailingAddr2,
      mailingCity,
      mailingCounty,
      mailingState,
      mailingzip,
      mailingZip4,
      addressOfRep,
      addressOfRep2,
      address3,
      authRepCity,
      authRepState,
      authRepZip,
      authZip4,
    } = this.state.data;
    this.AuthAddressFilled = true;
    if (
      addressOfRep ||
      addressOfRep2 ||
      address3 ||
      authRepCity ||
      authRepState ||
      authRepZip ||
      authZip4
    ) {
      if (addressOfRep && authRepCity && authRepState && authRepZip) {
        this.AuthAddressFilled = true;
      } else {
        this.AuthAddressFilled = false;
      }
    }
    this.mailingAddressFilled = true;
    if (
      mailingAddr ||
      mailingAddr2 ||
      mailingCity ||
      mailingCounty ||
      mailingState ||
      mailingzip ||
      mailingZip4
    ) {
      if (
        mailingAddr ||
        mailingCity ||
        mailingCounty ||
        mailingState ||
        mailingzip
        //Fixing address fileds save and next issue by ding && to ||
      ) {
        this.mailingAddressFilled = true;
      } else {
        this.mailingAddressFilled = false;
      }
    }
  };
  redirect = async (event, Soa2) => {
    event.persist();
    let id = event.target?.id;
    const payload2 = this.getData(this.state);
    this.MailingandAuthCheck();
    if (this.AuthAddressFilled === true) {
      if (this.mailingAddressFilled === true) {
        const response = await this.props.saveLogout(payload2);
        if (Soa2 != undefined) {
          this.setState({
            isSoaFilled: true,
          });
        }
        // if (this.state.selectedFiles.length && isNaN(response.data)===true) {
        //   this.setState({
        //     snackBarOpen: true,
        //     alertMsg:
        //       this.props.lang === "es"
        //         ? "Por favor complete los detalles básicos como Nombre y Número de Medicare para guardar Archivos/Firma"
        //         : "Kindly fill basic details like First Name & Medicare Number to save Files/Signature",
        //     severity: "error",
        //   });
        // } else {
        let c = 0;
        let n = 0;
        for (const element of this.state.selectedFiles) {
          // Update the formData object
          if (element.name !== undefined) {
            c = c + 1;
          }
        }
        if (this.state.selectedFiles.length) {
          const { preEnrollInfo, uploadedFilesInPreEnroll } = this.props;
          let prevSelectedFiles =
            preEnrollInfo?.attachmentList &&
            preEnrollInfo?.attachmentList?.length > 0
              ? [
                  ...preEnrollInfo.attachmentList.map(
                    (list) => list.attachmentName
                  ),
                  ...uploadedFilesInPreEnroll,
                ]
              : uploadedFilesInPreEnroll;
          for (const selectedFile of this.state?.selectedFiles) {
            if (!prevSelectedFiles.includes(selectedFile?.File?.name)) {
              const formData2 = new FormData();

              // Update the formData object
              if (selectedFile.name !== undefined) {
                const selectedIndex = this.props.typeOfFilesToUpload?.findIndex(
                  (type) => type.attachmentDesc === selectedFile.name
                );
                formData2.append(
                  "attachment",
                  selectedFile.File,
                  selectedFile.File.name
                );
                formData2.append("appNumber", response.data);
                formData2.append(
                  "attachmentType",
                  this?.props?.typeOfFilesToUpload[selectedIndex]
                    ?.attachmentType
                );
                formData2.append("customerId", this.props?.customerId);
                const resp = await this.props.uploadFile(
                  formData2,
                  selectedFile?.File?.name
                );
                if (resp?.message !== "SUCCESS") {
                  this.setState({
                    snackBarOpen: true,
                    alertMsg:
                      this.props.lang === "es"
                        ? "Error del sistema."
                        : "System Error.",
                    severity: "error",
                  });
                }
              }
            }
          }
        }
        this.verdaPdfUpload(response);
        // }

        window.scrollTo(0, 0);
        if (id === "next0") {
          await this.setState((prevState) => ({
            ...prevState,
            stepVal: "step1",
            SOA: Soa2,
          }));
        }
        if (id === "next2") {
          await this.setState({ stepVal: "step3" });
        }
        if (id === "next1") {
          await this.setState({ stepVal: "step2" });
        }
        if (id === "next3") {
          if (this.props.agentLogin === true) {
            await this.setState({ stepVal: "step4" });
          } else {
            await this.setState({ stepVal: "step1" });
          }
        }
        if (id === "next4") {
          await this.setState({ stepVal: "step5" });
        }
        if (id === "next5") {
          await this.setState({ stepVal: "step1" });
        }
      } else {
        if (id === "next1") {
          await this.setState({ stepVal: "step2" });
        }
        // this.setState({
        //   snackBarOpen: true,
        //   alertMsg:
        //     this.props.lang === "es"
        //       ? "Ingrese todos los campos para la dirección postal"
        //       : "Please enter all the fields for mailing address ",
        //   severity: "error",
        // });
        // return
      }
    } else {
      this.setState({
        snackBarOpen: true,
        alertMsg:
          this.props.lang === "es"
            ? "Ingrese todos los campos para la dirección del representante autorizado"
            : "Please enter all the fields for authorized representative address ",
        severity: "error",
      });
      return;
    }
  };
  formatPhoneNumber = (phoneNumberString) => {
    var match = phoneNumberString.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    return phoneNumberString;
  };
  handleNumberChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    value = value.replace(/[^0-9]/g, "");

    this.setState({ data: { ...this.state.data, [name]: value } });
  };
  handleDateNew = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    DateUtil.getStartDatePickerofMonth("#" + name).datepicker("hide");
    value = handleDateChangeNew(value);
    if (value.length === 10) {
      if (!moment(value, "MM/DD/YYYY", true).isValid()) {
        this.setState({
          snackBarOpen: true,
          alertMsg: "Please enter a valid date ",
          severity: "error",
        });
      }
      if (moment(value, "MM/DD/YYYY", true).isValid()) {
        if (name === "partAEffDate") {
          let splittedDate = value.split("/");
          if (splittedDate.length === 3) {
            if (splittedDate[2] !== "" && splittedDate[2].length === 4) {
              if (Number(splittedDate[1]) > 1) {
                this.setState({
                  snackBarOpen: true,
                  alertMsg: "Please enter first date of a month.",
                  severity: "error",
                  partAvalid: false,
                  // data: { ...this.state.data, [name]: "" },
                });
              } else {
                this.setState({
                  partAvalid: true,
                });
              }
            }
          }
        }
        if (name === "partBEffDate") {
          let splittedDate = value.split("/");
          if (splittedDate.length === 3) {
            if (splittedDate[2] !== "" && splittedDate[2].length === 4) {
              if (Number(splittedDate[1]) > 1) {
                this.setState({
                  snackBarOpen: true,
                  alertMsg: "Please enter first date of a month.",
                  severity: "error",
                  partBvalid: false,
                  // data: { ...this.state.data, [name]: "" },
                });
              } else {
                this.setState({
                  partBvalid: true,
                });
              }
            }
          }
        }
        if (name === "proposedEffDate") {
          let splittedDate = value.split("/");
          // let currentYear = new Date().getFullYear();
          // let currentMonth = new Date().getMonth() + 1;
          if (splittedDate.length === 3) {
            if (splittedDate[2] !== "" && splittedDate[2].length === 4) {
              // this.CalcNext3months();
              // if (
              //   (splittedDate[1].toString() === "01" &&
              //     Number(splittedDate[0]).toString() ===
              //       nxtFirstMonth.toString() &&
              //     Number(splittedDate[2]).toString() ===
              //       nxtFirstMonthYear.toString()) ||
              //   (Number(splittedDate[0]).toString() ===
              //     nxtSecondMonth.toString() &&
              //     Number(splittedDate[2]).toString() ===
              //       nxtSecondMonthYear.toString()) ||
              //   (Number(splittedDate[0]).toString() ===
              //     nxtThirdMonth.toString() &&
              //     Number(splittedDate[2]).toString() ===
              //       nxtThirdMonthYear.toString())
              // ) {
              //   this.setState({
              //     proposedvalid: true,
              //   });
              // } else {
              //   this.setState({
              //     snackBarOpen: true,
              //     alertMsg:
              //       "Please enter first date of next 3 months of current year.",
              //     severity: "error",
              //     proposedvalid: false,
              //     // data: { ...this.state.data, [name]: "" },
              //   });
              // }
              var dt = new Date();
              var mon = dt.getMonth() + 1;
              var year = dt.getFullYear();
              var planYear = Number(this.props.year);
              // var planYear =  Number(splittedDate[2])
              let nxtFirstMonth = mon + 1,
                nxtSecondMonth = mon + 2,
                nxtThirdMonth = mon + 3;
              // let nxtFirstMonthYear=year,nxtSecondMonthYear=year,nxtThirdMonthYear=year
              if (planYear > year) {
                if (
                  splittedDate[1].toString() === "01" &&
                  (Number(splittedDate[0]) === 1 ||
                    Number(splittedDate[0]) === 2) &&
                  Number(splittedDate[2]) === year + 1
                ) {
                  this.setState({
                    proposedvalid: true,
                  });
                } else {
                  this.setState({
                    snackBarOpen: true,
                    alertMsg:
                      "Please enter first date of next 3 months of current year.",
                    severity: "error",
                    proposedvalid: false,
                  });
                }
              } else {
                if (nxtFirstMonth > 11) {
                  nxtFirstMonth = nxtFirstMonth - 12;
                  //  nxtFirstMonthYear=year+1
                }
                if (nxtSecondMonth > 11) {
                  nxtSecondMonth = nxtSecondMonth - 12;
                  // nxtSecondMonthYear=year+1
                }
                if (nxtThirdMonth > 11) {
                  nxtThirdMonth = nxtThirdMonth - 12;
                  // nxtThirdMonthYear=year+1
                }

                if (
                  splittedDate[1].toString() === "01" &&
                  Number(splittedDate[0]) > mon &&
                  ((Number(splittedDate[0]) === nxtFirstMonth &&
                    Number(splittedDate[2]) === year) ||
                    (Number(splittedDate[0]) === nxtSecondMonth &&
                      Number(splittedDate[2]) === year) ||
                    (Number(splittedDate[0]) === nxtThirdMonth &&
                      Number(splittedDate[2]) === year) ||
                    (Number(splittedDate[0]) === 12 &&
                      Number(splittedDate[2]) === year))
                ) {
                  this.setState({
                    proposedvalid: true,
                  });
                } else {
                  this.setState({
                    snackBarOpen: true,
                    alertMsg:
                      "Please enter first date of next 3 months of current year.",
                    severity: "error",
                    proposedvalid: false,
                  });
                }
              }
            }
          }
          // if (splittedDate.length === 3) {
          //   if (splittedDate[2] !== "" && splittedDate[2].length === 4) {
          //     if(this?.props?.year===currentYear?.toString()){
          //     if (
          //       Number(splittedDate[1]) > 1 ||
          //       splittedDate[2] != currentYear ||
          //       (splittedDate[0] != "" &&
          //         splittedDate[0].length === 2 &&
          //         (currentMonth + 3 < splittedDate[0] ||
          //           splittedDate[0] <= currentMonth))
          //     ) {
          //       this.setState({
          //         snackBarOpen: true,
          //         alertMsg:
          //           "Please enter first date of next 3 months of current year.",
          //         severity: "error",
          //         proposedvalid: false,
          //         // data: { ...this.state.data, [name]: "" },
          //       });
          //     } else {
          //       this.setState({
          //         proposedvalid: true,
          //       });
          //     }
          //   }
          //   else{
          //     //selected year is greater than current year
          //     if (
          //       splittedDate[1] != "01" ||
          //       (splittedDate[2] != this?.props?.year) ||
          //       splittedDate[0] === "" ||
          //           splittedDate[0]!="01"
          //     ) {
          //       this.setState({
          //         snackBarOpen: true,
          //         alertMsg:
          //           // "Please enter first date of January of the selected year.",
          //           `Invalid effective date for ${this?.props?.year} plan year`,
          //         severity: "error",
          //         proposedvalid: false,
          //         // data: { ...this.state.data, [name]: "" },
          //       });
          //     } else {
          //       this.setState({
          //         proposedvalid: true,
          //       });
          //     }
          //   }
          //   }
          // }
        }
      }
    }
    await this.setState({
      data: { ...this.state.data, [name]: value },
    });
    // DateUtil.getRequEfftDatePicker("#" + name,this?.props?.year).datepicker("show");
  };
  handleDate = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    if (name === "partAEffDate" || name === "partBEffDate") {
      // DateUtil.getStartDatePickerofMonth("#" + name).datepicker("hide");
    } else {
      DateUtil.getDatePicker("#" + name).datepicker("hide");
    }
    value = handleDateChange(value);
    if (name === "proposedEffDate") {
      let splittedDate = value.split("/");
      if (splittedDate.length === 3) {
        if (
          splittedDate[2] !== "" &&
          Number(splittedDate[2]) >= new Date().getFullYear()
        ) {
          if (
            Number(splittedDate[2]) > new Date().getFullYear() &&
            Number(splittedDate[1]) > 1
          ) {
            this.setState({
              snackBarOpen: true,
              alertMsg: "Please enter first date of current & future month.",
              severity: "error",
              data: { ...this.state.data, [name]: "" },
            });
            return;
          }
          if (
            Number(splittedDate[2]) === new Date().getFullYear() &&
            (Number(splittedDate[0]) <= new Date().getMonth() ||
              Number(splittedDate[1]) > 1)
          ) {
            this.setState({
              snackBarOpen: true,
              alertMsg: "Please enter first date of a current & future month.",
              severity: "error",
              data: { ...this.state.data, [name]: "" },
            });
            return;
          }
        } else {
          this.setState({
            data: { ...this.state.data, [name]: value },
          });
        }
        if (
          Number(splittedDate[2]) < new Date().getFullYear() &&
          value.length === 10
        ) {
          this.setState({
            snackBarOpen: true,
            alertMsg: "Please enter first date of a future month.",
            severity: "error",
            data: { ...this.state.data, [name]: "" },
          });
          return;
        }
      }
    }
    if (name === "birthDate") {
      DateUtil.getDatePicker("#" + name).datepicker("hide");
      let splittedDate = value.split("/");
      if (splittedDate.length === 3 && splittedDate[2] !== "") {
        if (new Date(value) > new Date()) {
          this.setState({
            snackBarOpen: true,
            alertMsg: "Birth date can't be a future date.",
            severity: "error",
            data: { ...this.state.data, [name]: "" },
          });
          // DateUtil.getDatePicker("#" + name).datepicker("show");
          return;
        }
      }
    }

    if (value === "") {
      this.setState({
        snackBarOpen: true,
        alertMsg: "Please enter date in the MM/DD/YYYY format",
        severity: "error",
      });
    }
    await this.setState({
      data: { ...this.state.data, [name]: value },
    });
    // if (name === "partAEffDate" || name === "partBEffDate") {
    //   DateUtil.getStartDatePickerofMonth("#" + name).datepicker("show");
    // }else{
    //   DateUtil.getDatePicker("#" + name).datepicker("show");
    // }
  };
  handleAttestationDate = async (event, currentDateid) => {
    let value = event.target.value;
    DateUtil.getDatePicker("#" + currentDateid).datepicker("hide");
    value = handleDateChange(value);

    if (value === "") {
      this.setState({
        snackBarOpen: true,
        alertMsg: "Please enter date in the MM/DD/YYYY format",
        severity: "error",
      });
    }
    await this.props.setStateParams("currentDateid", currentDateid);
    this.setDatesAttestation("", value, currentDateid);
    // DateUtil.getDatePicker("#" + currentDateid).datepicker("show");
  };
  saveSign = async (data3, flag) => {
    if (
      data3 ===
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAAtJREFUGFdjYAACAAAFAAGq1chRAAAAAElFTkSuQmCC"
    ) {
      this.setState({
        snackBarOpen: true,
        alertMsg: "Please fill signature.",
        severity: "error",
      });
      return;
    }
    this.setState({
      data: { ...this.state.data, agentSign: data3 },
    });
    const appNumber = this.props.pendingApplFlag
      ? this.props?.appNum
      : this.props.guestbeneagentAppNum
      ? this.props.guestbeneagentAppNum
      : this.props.count
      ? this.props.count
      : null;
    if (appNumber != null && flag) {
      const sig = await this.props.uploadSign({
        attachmentType: "SIGN",
        signature: data3,
        customerId: this.props?.customerId,
        appNumber: appNumber,
      });
      if (sig.message !== "SUCCESS") {
        this.setState({
          snackBarOpen: true,
          alertMsg:
            this.props.lang === "es" ? "Error del sistema." : "System Error.",
          severity: "error",
        });
        return;
      } else {
        this.setState({
          snackBarOpen: true,
          alertMsg:
            this.props.lang === "es"
              ? "Firma cargada con éxito."
              : "Signature uploaded successfully.",
          severity: "success",
        });
      }
    }
    // else {
    //   if (flag) {
    //     this.setState({
    //       snackBarOpen: true,
    //       alertMsg:
    //         this.props.lang === "es"
    //           ? "Por favor complete los detalles básicos como Nombre y Número de Medicare para guardar Archivos/Firma"
    //           : "Kindly fill and save basic details like First Name & Medicare Number to save Files/Signature",
    //       severity: "error",
    //     });
    //   }
    // }
  };
  clear = () => {
    this.setState({
      data: { ...this.state.data, agentSign: "" },
    });
  };
  viewFile = async (index, name, e) => {
    let viewurl = this.state.urlList[index]?.url;

    if (viewurl === undefined) {
      e.preventDefault();
      const payload = {
        appNumber: this?.props?.appNum,
        customerId: this?.props?.customerId,
        attachmentType: name.split("_")[1],
        attachmentName: name.split("\\")[5],
      };
      const response = await this?.props.downloadFormsPdf(payload);
      if (response.status === "OK") {
        const blob = "data:application/pdf;base64," + response.data;
        saveAs(blob, name);
      }
      // await this.setState({
      //   snackBarOpen: true,
      //   alertMsg: "cannot view the file",
      //   severity: "error",
      // });
    }
    this.setState({
      ...this.state,
      viewurl: viewurl,
    });
  };
  removeFile = async (index, name) => {
    let files = this.state.selectedFiles;
    let urlArray = this.state.urlList;
    // if data  available in the Backend, thn removing
    if (
      this.props.preEnrollInfo.attachmentList !== undefined &&
      this.props.preEnrollInfo.attachmentList.length > 0
    ) {
      let isavailable = false;
      for (let i = 0; i < this.props.preEnrollInfo.attachmentList.length; i++) {
        if (
          this.props.preEnrollInfo.attachmentList[i].attachmentName === name
        ) {
          isavailable = true;
          break;
        }
      }
      if (isavailable === true) {
        await this.props.deleteFile({
          appNumber: this.props.preEnrollInfo.appNumber,
          attachmentId: this.state.selectedFiles[index].attachmentId,
          attachmentName: this.state.selectedFiles[index].attachmentName,
          customerId: this.props?.customerId,
        });
      }
    }
    files = files.filter((file, index1) => index1 !== index);
    urlArray.splice(index, 1);
    this.setState((prevState) => ({
      ...prevState,
      selectedFiles: files,
      urlList: urlArray,
      data: { ...this.state.data, [name]: "" },
    }));
  };
  handleQuestionId = (questionId, selected) => {
    this.setState((prevState) => ({
      ...prevState,
      questionIdSelected: questionId,
      selectedValue: selected,
    }));
  };

  handlePermanentAddresses = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({
      data: {
        ...this.state.data,
        permanentAddress: {
          ...this.state.data.permanentAddress,
          [name]: value,
        },
      },
      // newstate
    });
  };

  handleSuggestion = (name) => async (event) => {
    const value = event.target
      ? event.target.value
      : event.label || event.value;
    await this.setState({ data: { ...this.state.data, [name]: value } });
  };
  handleRaceAndEthic = async (event) => {
    let value = event.target.value;
    let name = event.target.name;
    let ethnicity1 = this.state.data.ethnicityRace;

    if (ethnicity1.some((item) => item.piValue === value)) {
      for (let i = 0; i < ethnicity1.length; i++) {
        if (ethnicity1[i].piValue === value) {
          // ethnicity1.pop({"piCode":name,"piValue": value})
          ethnicity1.splice(i, 1);
        }
      }
    } else {
      if (
        ethnicity1.some((item) => item.piValue === "999") &&
        name === "RACE"
      ) {
        return;
      }
      if (
        ethnicity1.some((item) => item.piValue === "NR") &&
        name === "ETHNICITY"
      ) {
        return;
      }
      let maxRace = ethnicity1.filter((code) => {
        return code.piCode === "RACE";
      });
      if (name === "RACE" && value !== "999") {
        if (maxRace?.length < 5) {
          ethnicity1.push({ piCode: name, piValue: value });
        } else {
          return;
        }
      } else {
        ethnicity1.push({ piCode: name, piValue: value });
      }
      if (value === "999" && name === "RACE") {
        ethnicity1 = ethnicity1.filter((item) => item.piCode === "ETHNICITY");
        ethnicity1.push({ piCode: name, piValue: value });
      }
      if (value === "NR" && name === "ETHNICITY") {
        ethnicity1 = ethnicity1.filter((item) => item.piCode === "RACE");
        ethnicity1.push({ piCode: name, piValue: value });
      }
    }

    await this.setState({
      data: { ...this.state.data, ethnicityRace: ethnicity1 },
    });
  };
  OnBlurpermananentZip4 = async (e) => {
    e.preventDefault();
    let isValidpermntZip4 =
      this.state?.data?.permanentZip4?.length === 4 ||
      this.state?.data?.permanentZip4 === "";
    await this.setState({
      isValidpermntZip4: isValidpermntZip4,
    });
    if (!this.state?.isValidpermntZip4) {
      this.setState({
        snackBarOpen: true,
        alertMsg: "Please enter valid Zip!",
        severity: "error",
      });
    }
  };
  OnBlurmailZip4 = async (e) => {
    e.preventDefault();
    let isValidmailZip4 =
      this.state?.data?.mailingZip4?.length === 4 ||
      this.state?.data?.mailingZip4 === "";
    await this.setState({
      isValidmailZip4: isValidmailZip4,
    });
    if (!this.state?.isValidmailZip4) {
      this.setState({
        snackBarOpen: true,
        alertMsg: "Please enter valid Zip!",
        severity: "error",
      });
    }
  };
  OnBlurauthZip4 = async (e) => {
    e.preventDefault();
    let isValidauthZip4 =
      this.state?.data?.authZip4?.length < 4 &&
      this.state?.data?.authZip4?.length > 0
        ? false
        : true;
    await this.setState({
      isValidauthZip4: isValidauthZip4,
    });
    if (!this.state?.isValidauthZip4) {
      this.setState({
        snackBarOpen: true,
        alertMsg: "Please enter valid Zip!",
        severity: "error",
      });
    }
  };
  OnBlurEmailAddr = (e) => {
    e.preventDefault();
    let isValidEmail = this.validator.check(
      this.state.data.emailAddress,
      "email"
    );
    if (!isValidEmail) {
      this.setState({
        snackBarOpen: true,
        alertMsg: "Please enter valid email address.",
        severity: "error",
      });
    }
  };
  handleChange = async (event) => {
    event.persist();
    let name = event.target.name;
    let value = event.target.value;
    if (
      name === "firstName" ||
      name === "lastName" ||
      name === "permanentAddrStreet" ||
      name === "permanentAddr2" ||
      name === "nameOfRep" ||
      name === "lastNameOfRep" ||
      name === "nameOfCoverage" ||
      name === "covMemberNumber" ||
      name === "covGroupNumber" ||
      name === "nameOfInstitution" ||
      name === "addrOfInstitution" ||
      name === "addressOfRep" ||
      name === "addressOfRep2" ||
      name === "address3" ||
      name === "name" ||
      name === "mailingAddr2" ||
      name === "mailingAddr" ||
      name === "mailingCity" ||
      name === "authRepCity" ||
      name === "permanentCity" ||
      name === "acctholdername" ||
      name === "bankName" ||
      name === "othLang" ||
      name === "attestationOther" ||
      name === "prefLngOthrValue"
    ) {
      value = event.target.value.toUpperCase().trimStart();
    } else {
      value = event.target.value.toUpperCase()?.trim();
    }

    if (name.toLowerCase().includes("middleinitial")) {
      if (value.length > 1) {
        value = value.slice(0, 1);
      }
    }

    if (name.toLowerCase().includes("filetype")) {
      value = event.target ? event.target.value : event.value;
      this.setState({
        fileType: value,
      });
    }
    if (name.toLowerCase().includes("fileupload")) {
      let otherType = this.state.selectedFiles.filter(
        (file1) =>
          file1?.name === "OTHERS" || file1?.attachmentType === "OTHERS"
      );
      let filetype = this.state.fileType;
      if (otherType?.length === 3 && filetype === "OTHR") {
        this.setState({
          ...this.state,
          fileType: "",
          snackBarOpen: true,
          alertMsg: "Maximum three Other Type can be uploaded",
          severity: "warning",
        });
        return;
      }

      let file = event.target ? event.target.files[0] : event.files[0];
      // checking file type for BCBSN
      let acceptedTypes = ["application/pdf", "image/jpeg", "image/png"];
      if (
        !acceptedTypes.includes(file.type)
        //  && NEBRASKA_CONSTS.ID === this.props.customerId
        //** */ Validation added for all products
      ) {
        this.setState({
          ...this.state,
          fileType: "",
          snackBarOpen: true,
          alertMsg:
            "Only PDF and image (PNG/ JPG) file formats are supported for document upload.",
          severity: "error",
        });
        return;
      }

      let fileSize = (file.size * 0.001) / 1024;
      if (fileSize > 25) {
        this.setState({
          snackBarOpen: true,
          alertMsg: "Please upload a file having less than 25 MB size",
          severity: "error",
        });
        return;
      }

      let url = URL.createObjectURL(event.target.files[0]);
      // window.open(url)
      let fileName = this.props.typeOfFilesToUpload.filter(
        (data1) => data1.attachmentType === filetype
      )[0];
      let files = this.state.selectedFiles;
      if (filetype !== "OTHR") {
        files = this.state.selectedFiles.filter((file1) => {
          if (file1.name) {
            return file1.name !== fileName.attachmentDesc;
          } else {
            return file1.attachmentType !== fileName.attachmentDesc;
          }
        });
      }

      let dataCopy = this.state.data;
      let urlArray = this.state.urlList;
      this.setState((prevState) => ({
        ...prevState,
        url: url,
        urlList: [...urlArray, { url: url, name: fileName.attachmentDesc }],
        selectedFiles: [
          ...files,
          { File: file, name: fileName.attachmentDesc },
        ],
      }));

      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = (e) => {
        this.setState((prevState) => ({
          ...prevState,
          selectedFiles: [
            ...files,
            { File: file, name: fileName.attachmentDesc },
          ],
          fileType: "",
          data: { ...dataCopy, [filetype]: e.target.result },
        }));
      };
    }
    if (name.toLowerCase().includes("mailingcity")) {
      value = value.replace(/[^A-Z- ]/g, "");
    }
    if (name.toLowerCase().includes("mailingstate")) {
      value = value.replace(/[^A-Z]/g, "");
    }
    if (
      name.includes("authZip4") ||
      name.includes("permanentZip4") ||
      name.includes("mailingZip4") ||
      name.includes("authRepZip")
    ) {
      value = value.replace(/[^0-9]/g, "");
    }
    if (name.toLowerCase().includes("mailingzip")) {
      value = value.replace(/[^0-9]/g, "");
      if (value?.length === 5) {
        const response = await this.props.getMailZipCodes(value);
        if (response.data === null) {
          //await this.props.setStateParams("mailingZipCodes", []);
          await this.props.setCampaignProspectStateParams("mailzipCodes", []);
          this.setState({
            data: {
              ...this.state.data,
              mailingState: "",
              mailingCity: "",
              mailingCountyCd: "",
            },
            snackBarOpen: true,
            alertMsg: response.message,
            severity: "error",
          });
        } else {
          this.setState({
            snackBarOpen: false,
          });
          await this.props.setCampaignProspectStateParams(
            "mailzipCodes",
            response?.data
          );
          if (response.data.length === 1) {
            await this.setState({
              data: {
                ...this.state.data,
                mailingCounty: response?.data[0]?.countyName,
                mailingCountyCd: response?.data[0]?.countyCode,
                mailingState: response?.data[0]?.stateCd,
                mailingCity: response?.data[0]?.cityName,
              },
            });
          }
          if (response.data.length > 1) {
            await this.setState({
              data: {
                ...this.state.data,
                mailingCounty: response?.data[0]?.countyName,
                mailingCountyCd: response?.data[0]?.countyCode,
                mailingState: response?.data[0]?.stateCd,
                mailingCity: response?.data[0]?.cityName,
              },
            });
          }
        }
      }
    }
    if (name.toLowerCase().includes("phone")) {
      value = this.formatPhoneNumber(value.replace(/[^0-9]/g, ""));
    }
    if (name.toLowerCase().includes("cellphonenum")) {
      if (
        (value.length != 0 || value.length != undefined) &&
        value.length < 10
      ) {
        validCheck = false;
      }
      if (value.length >= 10 || value.length == 0) {
        validCheck = true;
      }
    }
    if (
      name.toLowerCase().includes("covmembernumber") ||
      name.toLowerCase().includes("covgroupnumber")
    ) {
      value = value.replace(/[^a-z-A-Z0-9\s]/g, "");
    }
    if (
      name.toLowerCase().includes("firstname") ||
      name.toLowerCase().includes("lastname") ||
      name.toLowerCase().includes("middleinitial") ||
      name.toLowerCase().includes("permanentCity") ||
      name.toLowerCase().includes("nameofrep") ||
      name.toLowerCase().includes("nameofcoverage")
    ) {
      //value = value.replace(/[^a-z-A-Z- --]/g, "");
      value = value.replace(/[^a-z-A-Z\s]/g, "");
    }

    if (name.includes("medicaidId")) {
      value = value.replace(/[^0-9-a-z-A-Z-]/g, "");
    }
    if (name.includes("medicareNumber")) {
      let valid = false;

      if (value.length > 0) {
        if (value != this.state.mandatoryMbi) {
          let temp = "";
          for (let i = 0; i < value.length; i++) {
            if (i === 1 || i === 4 || i === 7 || i === 8) {
              valid = value.charAt(i).match(/[A-Z]/) ? true : false;
              if (valid === true) {
                valid = !(
                  value.charAt(i) === "S" ||
                  value.charAt(i) === "L" ||
                  value.charAt(i) === "O" ||
                  value.charAt(i) === "I" ||
                  value.charAt(i) === "B" ||
                  value.charAt(i) === "Z"
                );

                if (valid === true) {
                  temp = temp + value[i];
                }
              }
            }
            if (i === 0 || i === 3 || i === 6 || i === 9 || i === 10) {
              valid = !isNaN(value[i]);

              if (valid === true) {
                temp = temp + value[i];
              }
            }
            if (i === 2 || i === 5) {
              valid = value[i].match(/[A-Z]/) ? true : false;
              if (valid === true) {
                valid = !(
                  value.charAt(i) === "S" ||
                  value.charAt(i) === "L" ||
                  value.charAt(i) === "O" ||
                  value.charAt(i) === "I" ||
                  value.charAt(i) === "B" ||
                  value.charAt(i) === "Z"
                );
              }
              valid = !isNaN(value[i]) || valid;
              if (valid === true) {
                temp = temp + value[i];
              }
            }
            if (valid === false || valid === null) {
              this.setState({
                snackBarOpen: true,
                alertMsg:
                  this.props.lang === "en"
                    ? "Please enter mbi in correct format"
                    : "Por favor ingrese mbi en el formato correcto",
                severity: "error",
              });
            }
          }
          this.setState({
            mandatoryMbi: temp,
          });
        }
      } else {
        this.setState({
          mandatoryMbi: "",
        });
      }
    }
    if (name.includes("permanentAddrStreet")) {
      if (poArray.some((pos) => value.trimStart().startsWith(pos))) {
        this.setState({
          snackBarOpen: true,
          alertMsg: "Please fill the permanent address without PO Box",
          severity: "error",
        });
      }
    }
    if (
      event.target.type === "checkbox" &&
      (name !== "language" || name !== "languageCheck")
    ) {
      value = event.target.checked ? true : false;
    }

    if (
      event.target.type === "checkbox" &&
      (name === "prefLng" || name === "textIndicator")
    ) {
      value = event.target.checked ? event.target.value : "";
    }
    if (name === "renalDisease" && value === "N") {
      this.setState({
        data: { ...this.state.data, [name]: value, esrdcontact: "" },
      });
      return;
    }

    if (name === "isDrugCoverage" && value === "N") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          nameOfCoverage: "",
          covMemberNumber: "",
          covGroupNumber: "",
        },
      });
      return;
    }
    if (name === "isAuthRepresentative" && value === "N") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          nameOfRep: "",
          lastNameOfRep: "",
          middleNameOfRep: "",
          addressOfRep: "",
          addressOfRep2: "",
          address3: "",
          authRepCity: "",
          authRepState: "",
          authRepZip: "",
          authZip4: "",
          phoneNumberOfRep: "",
          relationOfRep: "",
        },
      });
      return;
    }
    if (name === "isLicensedSalesRep" && value === "N") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          salRepName: "",
        },
      });
      return;
    }
    if (name === "medicaidInd" && value === "N") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          medicaidId: "",
        },
      });
      return;
    }
    if (name === "ltcInd" && value === "N") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          nameOfInstitution: "",
          addrOfInstitution: "",
        },
      });
      return;
    }
    if (name === "medicaidprg" && value === "N") {
      this.setState({
        data: { ...this.state.data, [name]: value, medicaidNbr: "" },
      });
      return;
    }
    if (name === "prescriptionDrug" && value === "N") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          nameOfInst: "",
          phoneOfInst: "",
          addrOfInst: "",
        },
      });
      return;
    }
    if (name === "retiree" && value === "N") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          retiredate: "",
          coveringSpouseOrDependent: "",
          coveringSpouseOrDependentEmployeeName: "",
          coveringSpouseOrDependentMiddleName: "",
          coveringSpouseOrDependentFirstName: "",
          coveringSpouseOrDependentLastName: "",
        },
      });
      return;
    }
    if (name === "retiree" && value === "Y") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          retirename: "",
          survivingSpouseCitySanDiegoRetiree: "",
          survivingSpouseCitySanDiegoRetireeLastName: "",
          survivingSpouseCitySanDiegoRetireeFirstName: "",
          survivingSpouseCitySanDiegoRetireeMiddleName: "",
        },
      });
      return;
    }

    if (name === "coveringSpouseOrDependent" && value === "Y") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          coveringSpouseOrDependentEmployeeName: "",
        },
      });
      return;
    }
    if (name.toLowerCase().includes("isauthrepresentative") && value == "N") {
      this.setState({
        data: {
          ...this.state.data,
          authRepState: "",
          [name]: value,
        },
      });
      return;
    }
    if (name === "coveringSpouseOrDependent" && value === "N") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          coveringSpouseOrDependentMiddleName: "",
          coveringSpouseOrDependentFirstName: "",
          coveringSpouseOrDependentLastName: "",
        },
      });
      return;
    }
    if (name === "coveringSpouseOrDependentEmployeeName" && value === "N") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          survivingSpouseCitySanDiegoRetireeLastName: "",
          survivingSpouseCitySanDiegoRetireeFirstName: "",
          survivingSpouseCitySanDiegoRetireeMiddleName: "",
        },
      });
      return;
    }
    if ((name === "empCover" || name === "meddependsp") && value === "N") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          dependentSpouse: "",
          dependentOther: "",
        },
      });
      return;
    }
    if (name === "emailOptionIndicator") {
      // let fval=
      // event.target.defaultValue
      // ?event.target.defaultValue
      // event.target.checked ? event.target.defaultValue??"Y" : this.props.customerId!==VERDA_CONSTS.ID?"":"N";
      this.props.setStateParams(
        "emailoptionChecked",
        event.target.checked ? "Y" : "N"
      );
      this.setState({
        data: {
          ...this.state.data,
          [name]: event.target.checked ? "Y" : "N",
        },
      });

      return;
    }
    if (name === "termsAndConditions" || name === "verbiage") {
      let name1 =
        this.props.customerId === VERDA_CONSTS.ID
          ? event.target.checked
            ? this.state.data.name
            : ""
          : this.state.data.name;
      this.setState({
        data: {
          ...this.state.data,
          [name]: event.target.checked ? "Y" : "N",
          name: name1,
        },
      });

      return;
    }
    if (name === "accessibleFormatVal") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: this.state.data.accessibleFormatVal === value ? "" : value,
          accessibleFormatOthersVal: "",
        },
      });
      return;
    }
    if (name === "permanentCounty" && value !== "") {
      let state = this.props.ZipCodes.filter((zip) =>
        zip.countyName.includes(value)
      );
      this.props.setStateParams("preEnrollInfo", {});
      this.props.setStateParams("stateId", state[0].stateCd);
      this.props.setStateParams("CountyCd", state[0].countyCode);
    }
    if (name === "mailingCounty" && this.props.mailzipCodes?.length > 1) {
      let mailingState = this.props.mailzipCodes.filter(
        (x) => x.countyName === value
      )[0]?.stateCd;
      let mailingCountyCd = this.props.mailzipCodes.filter(
        (x) => x.countyName === value
      )[0]?.countyCode;
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          mailingState,
          mailingCountyCd,
        },
      });
      return;
    }
    await this.setState({ data: { ...this.state.data, [name]: value } });
    if (name.toLowerCase().includes("nameofinstitution")) {
      let address =
        this.props.ltcList &&
        this.props.ltcList?.filter((address1) =>
          address1.label.includes(this.state?.data.nameOfInstitution)
        )[0] != undefined
          ? this.props.ltcList?.filter((address2) =>
              address2.label.includes(this.state?.data.nameOfInstitution)
            )[0].value
          : "";
      await this.setState({
        data: { ...this.state.data, addrOfInstitution: address },
      });
    }
    if (
      this.state.data.mailingAddressRequired === "YES" &&
      name.toLowerCase().includes("permanent")
    ) {
      const {
        permanentAddrStreet,
        permanentAddr2,
        permanentCity,
        permanentZip,
        permanentZip4,
      } = this.state.data;
      // let permanentCounty = this.props.preEnrollInfo.appNumber
      //   ? this.props.deeplink
      //     ? this.props.dpcountyName
      //     : this.props.preEnrollInfo.permanentAddress.county
      //   : this.props.deeplink
      //   ? this.props.dpcountyName
      //   : this.props?.ZipCodes?.length > 0
      //   ? this.props?.ZipCodes.filter(
      //       (x) => x.stateCd === this.props.stateId
      //     )[0].countyName
      //   : this.props?.ZipCodes[0]?.countyName;
      let permanentCounty =
        this.props?.ZipCodes && this.props.ZipCodes.length > 1
          ? this?.state?.data?.permanentCounty
          : this?.props?.mbiDetails?.status === "MATCHED"
          ? this?.state?.data?.permanentCounty
          : this.props.preEnrollInfo.appNumber
          ? this.props.deeplink
            ? this.props.dpcountyName
            : this.props.preEnrollInfo.permanentAddress.county
          : this.props.deeplink
          ? this.props.dpcountyName
          : this.props?.ZipCodes[0]?.countyName;
      let mailingAddr = permanentAddrStreet;
      let mailingCity = permanentCity;
      let mailingState = this.props.stateId;
      let mailingzip = permanentZip;
      let mailingAddr2 = permanentAddr2;
      let mailingZip4 = permanentZip4;
      let mailingCounty = permanentCounty;
      let mailingCountyCd = this.props.CountyCd;
      await this.setState({
        data: {
          ...this.state.data,
          mailingAddr,
          mailingCity,
          mailingState,
          mailingzip,
          mailingAddr2,
          mailingZip4,
          mailingCounty,
          mailingCountyCd,
        },
      });
    }
  };
  goBack = async (event) => {
    event.preventDefault();
    // if (this.props?.prospectEnroll === true) {
    // this.props.setLoginStateParams("sepReasonforS",[])
    history.push("/e-Enroll/dashboard");
    // }
    // else {
    //   history.goBack();
    // }
    this.props.setStateParams("planType", "");
    this.props.setStateParams("selectedProduct", "");
    this.props.setStateParams("selectedPlansForCompare", []);
  };
  changePlan = async (event) => {
    this.props.setLoginStateParams("sepReasonforS", []);
    this.props.setStateParams("Submitted", false);
    await this.props.setCampaignProspectStateParams("mailzipCodes", []);
    // if(mbiDetails?.data?.permanentAddress){
    // await this.props.setStateParams("stateId",mbiDetails?.data?.permanentAddress?.state);
    // await this.props.setStateParams("zip",mbiDetails?.data?.permanentAddress?.zipCode);
    // }
    if (this?.props?.MBIDetails?.data?.permanentAddress) {
      await this.props.setStateParams(
        "stateId",
        this?.props?.MBIDetails?.data?.permanentAddress?.state
      );
      await this.props.setStateParams(
        "zip",
        this?.props?.MBIDetails?.data?.permanentAddress?.zipCode
      );
    }
    event.preventDefault();
    this.props.setLoginStateParams("deeplink", false);
    this.props.setStateParams("Submitted", false);
    if (
      this.props?.dpzipCode != "" &&
      this.props?.dpzipCode != null &&
      this.props?.dpzipCode != undefined &&
      this.props?.deeplink === true
    ) {
      this.props.setStateParams("zip", this.props?.dpzipCode);
      this.props.setStateParams("county", this.props?.dpcountyName);
    }
    if (this.props.pendingApplFlag === true) {
      await this.props.getZipCodes(
        this.state.data.permanentAddress.zipCode || this.props.zipCode
      );
      this.props.setStateParams(
        "zip",
        this.state.data.permanentAddress.zipCode || this.props.zipCode
      );
    }
    const { permanentAddress } = this.state.data;
    const stateCd = this.props.stateCd;
    let cntyCd = this.props.ZipCodes.filter(
      (x) => x.countyName === this.props.countyName
    )[0]?.countyCode;
    if (this.props.cardDetails.length === 0) {
      let customerId = this.props?.customerId;
      await this.props.getPlans(
        permanentAddress?.zipCode || this.props.zipCode,
        permanentAddress?.countyCd || cntyCd,
        customerId,
        stateCd,
        this?.props?.year
      );
    }
    //await this.props.setStateParams("preEnrollInfo", {});
    if (this?.props?.prospectEnroll !== true) {
      await this.props.setStateParams("soa", {});
      await this.props.setStateParams("preEnrollInfo", {});
      await this.props.setLoginStateParams("mbiDetails", {});
    }
    this.props.setStateParams("planType", "");
    this.props.setStateParams("selectedProduct", "");
    this.props.setStateParams("selectedPlansForCompare", []);
    history.push("/e-Enroll/select-plan");
  };
  checkEligibility = async () => {
    const { medicareNumber, birthDate } = this.state.data;
    if (medicareNumber === "" || birthDate === "") {
      this.setState({
        snackBarOpen: true,
        alertMsg:
          this.props.lang === "en"
            ? "Fields Medicare Number & Date of Birth are required!"
            : "Los campos Número de Medicare y Fecha de nacimiento son obligatorios.",
        severity: "error",
      });
    } else {
      let payload = {
        mbi: medicareNumber,
        //lastName: lastName,
        dob: birthDate,
        customerId: this.props?.customerId,
      };
      let response = await this.props.checkEligibility(payload);
      let msg =
        response.data.eligible === true
          ? "Medicare ID verified"
          : response.data.errorMessage;
      let severity = response.data.eligible === true ? "success" : "error";
      this.setState({
        snackBarOpen: true,
        alertMsg: msg,
        severity: severity,
      });

      if (
        response.data.partAEffDate != null &&
        response.data.partBEffDate != null
      ) {
        let partAEffDate = new Date(
          response.data.partAEffDate
        ).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
        let partBEffDate = new Date(
          response.data.partBEffDate
        ).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });

        this.setState({
          data: {
            ...this.state.data,
            partAEffDate: partAEffDate,
            partBEffDate: partBEffDate,
          },
        });
      }
    }
  };

  pcpChange = (name) => async (event) => {
    const name1 = event.target ? event.target.name : name;
    const value = event.target
      ? event.target.value
      : event.value || event.label;
    const plan = this.state.selectedPlan;
    if (plan !== "SDAHMO1") {
      this.setState({
        data: {
          ...this.state.data,
          [name1]: value,
          pcpMedicalGroupName: event.target
            ? event.target.clinicName
            : event.clinicName,
          clinicName: event.target ? event.target.clinicName : event.clinicName,
        },
      });
    } else {
      this.setState({
        data: {
          ...this.state.data,
          [name1]: value,
        },
      });
    }
  };
  setRuLanguage = async () => {
    if (lang === "en") {
      await setLanguage("es");
      lang = "es";
    } else {
      await setLanguage("en");
      lang = "en";
    }
  };
  setQSNS = (attestationList, dateInd, qnId) => {
    let getSubqnId = attestationList.map((qs) => {
      return this.props.qsns.filter((el) => el.questionId === qs.qsnMetaId);
    });

    let SubqnId = [];
    for (let i = 0; i < getSubqnId.length; i++) {
      SubqnId.push(getSubqnId[i][0].answersvo[0]?.subQuestions);
    }
    let DateUpdated = [];
    DateUpdated = this.state?.questionDate.filter((qsn) => {
      if (SubqnId.includes(qsn.qsnMetaId)) {
        return qsn;
      }
    });
    // console.log("hind--",qnId,this.props.qsns,this.props.qsns.filter((qs)=>qs.questionId==qnId)[0].sepReasonCd)
    if (dateInd.length !== 0) {
      this.setState({
        ...this.state,
        attestationList: attestationList,
        dateInd: dateInd,
        questionDate: DateUpdated,
        data: {
          ...this.state.data,
          sepReasonCd: this.props.qsns.filter((qs) => qs.questionId == qnId)[0]
            .sepReasonCd,
        },
      });
    } else {
      this.setState({
        ...this.state,
        data: { ...this.state.data, questionDate: "" },
        attestationList: attestationList,
        dateInd: [{ dateInd: "n" }],
        questionDate: DateUpdated,
        data: {
          ...this.state.data,
          sepReasonCd: this.props.qsns.filter((qs) => qs.questionId == qnId)[0]
            .sepReasonCd,
        },
      });
    }
  };
  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      snackBarOpen: false,
    });
  };
  setSnackBar = (msg) => {
    this.setState({
      snackBarOpen: true,
      alertMsg: msg,
      severity: "error",
    });
  };
  mbiFunc = async () => {
    let mbiDetails1 = await this.props.mbiDetails({
      mbi: this?.state?.mandatoryMbi,
      effDate: this?.state?.data?.proposedEffDate,
    });
    if (mbiDetails1?.data?.status === "MATCHED") {
      await this.props.setStateParams(
        "stateId",
        mbiDetails1?.data?.permanentAddress?.state
      );
      await this.props.setStateParams(
        "zip",
        mbiDetails1?.data?.permanentAddress?.zipCode
      );
      await this.props.setStateParams(
        "CountyCd",
        mbiDetails1?.data?.permanentAddress?.countyCd
      );
      await this.props.setStateParams("zipCodes", []);
      await this.props.setCampaignProspectStateParams("mailzipCodes", []);
      let filteredmbiDetails = Object.keys(mbiDetails1?.data)
        .filter(
          (k) => mbiDetails1?.data[k] != null && mbiDetails1?.data[k] != ""
        )
        .reduce((a, k) => ({ ...a, [k]: mbiDetails1?.data[k] }), {});
      let phonenum = {
        primaryPhoneNum: this?.state?.data?.primaryPhoneNum,
        cellPhoneNum: this?.state?.data?.cellPhoneNum,
      };
      if (mbiDetails1?.data?.primaryPhoneNum?.length > 0) {
        phonenum = {
          primaryPhoneNum: this.formatPhoneNumber(
            mbiDetails1?.data?.primaryPhoneNum
          ),
          cellPhoneNum: this?.state?.data?.cellPhoneNum,
        };
      }
      if (mbiDetails1?.data?.cellPhoneNum?.length > 0) {
        phonenum = {
          primaryPhoneNum: this?.state?.data?.primaryPhoneNum,
          cellPhoneNum: this.formatPhoneNumber(mbiDetails1?.data?.cellPhoneNum),
        };
      }
      let permanentAddress = {
        permanentAddrStreet: mbiDetails1?.data?.permanentAddress?.streetAddress
          ? mbiDetails1?.data?.permanentAddress?.streetAddress
          : "",
        permanentAddr2: mbiDetails1?.data?.permanentAddress?.address2
          ? mbiDetails1?.data?.permanentAddress?.address2
          : "",
        permanentCity: mbiDetails1?.data?.permanentAddress?.city
          ? mbiDetails1?.data?.permanentAddress?.city
          : "",
        permanentCounty: mbiDetails1?.data?.permanentAddress?.county
          ? mbiDetails1?.data?.permanentAddress?.county
          : "",
        stateId: mbiDetails1?.data?.permanentAddress?.state
          ? mbiDetails1?.data?.permanentAddress?.state
          : "",
        state: mbiDetails1?.data?.permanentAddress?.state
          ? mbiDetails1?.data?.permanentAddress?.state
          : "",
        permanentZip: mbiDetails1?.data?.permanentAddress?.zipCode
          ? mbiDetails1?.data?.permanentAddress?.zipCode
          : "",
        zipCode: mbiDetails1?.data?.permanentAddress?.zipCode
          ? mbiDetails1?.data?.permanentAddress?.zipCode
          : "",
        permanentZip4: mbiDetails1?.data?.permanentAddress?.zip4
          ? mbiDetails1?.data?.permanentAddress?.zip4
          : "",
        CountyCd: mbiDetails1?.data?.permanentAddress?.countyCd
          ? mbiDetails1?.data?.permanentAddress?.countyCd
          : "",
      };
      let mailingAddress = {};
      if (this.state.data?.mailingAddressRequired === "YES") {
        mailingAddress = {
          mailingAddr: mbiDetails1?.data?.permanentAddress?.streetAddress
            ? mbiDetails1?.data?.permanentAddress?.streetAddress
            : "",
          mailingAddr2: mbiDetails1?.data?.permanentAddress?.address2
            ? mbiDetails1?.data?.permanentAddress?.address2
            : "",
          mailingCity: mbiDetails1?.data?.permanentAddress?.city
            ? mbiDetails1?.data?.permanentAddress?.city
            : "",
          mailingCounty: mbiDetails1?.data?.permanentAddress?.county
            ? mbiDetails1?.data?.permanentAddress?.county
            : "",
          mailingState: mbiDetails1?.data?.permanentAddress?.state
            ? mbiDetails1?.data?.permanentAddress?.state
            : "",
          mailingzip: mbiDetails1?.data?.permanentAddress?.zipCode
            ? mbiDetails1?.data?.permanentAddress?.zipCode
            : "",
          mailingZip4: mbiDetails1?.data?.permanentAddress?.zip4
            ? mbiDetails1?.data?.permanentAddress?.zip4
            : "",
          mailingCountyCd: mbiDetails1?.data?.permanentAddress?.countyCd
            ? mbiDetails1?.data?.permanentAddress?.countyCd
            : "",
        };
      }
      if (this.state.data?.mailingAddressRequired != "YES") {
        mailingAddress = {
          mailingAddr: mbiDetails1?.data?.mailingAddress?.streetAddress
            ? mbiDetails1?.data?.mailingAddress?.streetAddress
            : this?.state.data?.mailingAddr,
          mailingAddr2: mbiDetails1?.data?.mailingAddress?.address2
            ? mbiDetails1?.data?.mailingAddress?.address2
            : this?.state.data?.mailingAddr2,
          mailingCity: mbiDetails1?.data?.mailingAddress?.city
            ? mbiDetails1?.data?.mailingAddress?.city
            : this?.state.data?.mailingCity,
          mailingCounty: mbiDetails1?.data?.mailingAddress?.county
            ? mbiDetails1?.data?.mailingAddress?.county
            : this?.state.data?.mailingCounty,
          mailingState: mbiDetails1?.data?.mailingAddress?.state
            ? mbiDetails1?.data?.mailingAddress?.state
            : this?.state.data?.mailingState,
          mailingzip: mbiDetails1?.data?.mailingAddress?.zipCode
            ? mbiDetails1?.data?.mailingAddress?.zipCode
            : this?.state.data?.mailingzip,
          mailingZip4: mbiDetails1?.data?.mailingAddress?.zip4
            ? mbiDetails1?.data?.mailingAddress?.zip4
            : this?.state.data?.mailingZip4,
          mailingCountyCd: mbiDetails1?.data?.mailingAddress?.countyCd
            ? mbiDetails1?.data?.mailingAddress?.countyCd
            : this?.state.data?.mailingCountyCd,
        };
      }

      this.setState({
        data: {
          ...this.state.data,
          ...filteredmbiDetails,
          ...permanentAddress,
          ...mailingAddress,
          ...phonenum,
        },
      });
      // if(mbiDetails?.data?.permanentAddress?.zipCode){
      // await this.props.getZipCodes(mbiDetails?.data?.permanentAddress?.zipCode);
      // }
      // if(this.props?.ZipCodes && this.props.ZipCodes.length==1){
      //   this.setState({
      //     data: { ...this.state.data,permanentCounty: this.props?.ZipCodes[0]?.countyName },
      //   });
      // }
      // if(mbiDetails?.data?.mailingAddress?.zipCode){
      // await this.props.getMailZipCodes( mbiDetails?.data?.mailingAddress?.zipCode)
      // }
    }
  };
  async componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState?.scrollCount != this.state.scrollCount) {
      let set = document.getElementsByClassName("scrollfix");
      for (let i = 0; i < set.length; i++) {
        set[i].blur();
        $(set[i]).datepicker && $(set[i]).datepicker("hide");
      }
    }
    if (prevProps?.electionType != this?.props?.electionType) {
      if (
        this?.props?.electionType === "S" &&
        this.state?.attestationList?.length === 0
      ) {
        if (
          this.props?.sepReasonforS?.length === 0 &&
          this.props?.agentLogin === true
        ) {
          let sepresponse = await this.props?.getsepReasons({
            productName: this?.props?.product,
          });
          if (sepresponse?.status != "OK") {
            this.setState({
              ...this.state,
              snackBarOpen: true,
              alertMsg:
                "Some error occurred while fetching data. Please try later",
              severity: "warning",
            });
            return;
          }
        }
      }
    }
    if (prevState.attestationList != this.state?.attestationList) {
      if (this.state?.attestationList?.length > 0) {
        await this.setState({
          selectedQnId: [],
        });
        for (let i = 0; i < this.state?.attestationList?.length; i++) {
          await this.setState({
            selectedQnId: this?.state?.selectedQnId.concat(
              this.state?.attestationList[i].qsnMetaId
            ),
          });
        }
        if (this.props?.electionList?.length > 0) {
          if (this?.state?.selectedQnId?.length > 0) {
            let tp = this.props?.electionList.filter(
              (item) => this?.state?.selectedQnId[0] === item.questionId
            )[0]?.value;
            await this.props.setStateParams("electionType", tp ?? "S");
            if (tp === "S" && this?.state?.selectedQnId?.length === 0) {
              if (
                this.props?.sepReasonforS?.length === 0 &&
                this.props?.agentLogin === true
              ) {
                let sepres = await this.props?.getsepReasons({
                  productName: this?.props?.product,
                });
                if (sepres?.status != "OK") {
                  this.setState({
                    ...this.state,
                    snackBarOpen: true,
                    alertMsg:
                      "Some error occurred while fetching data. Please try later",
                    severity: "warning",
                  });
                  return;
                }
              }
            }
            this.setState({
              data: {
                ...this.state.data,
                sepReasonCd: this.props.qsns
                  .filter(
                    (qs) => qs.questionId == this?.state?.selectedQnId[0]
                  )[0]
                  ?.sepReasonCd?.trim(),
              },
            });
          }
        }
      } else {
        await this.props.setStateParams("electionType", "S");
        await this.setState({
          selectedQnId: [],
          data: { ...this.state.data, sepReasonCd: "" },
        });
      }
    }
    if (
      this.props.customerId != VERDA_CONSTS.ID &&
      this.props.agentLogin === true &&
      (prevState?.mandatoryMbi != this?.state?.mandatoryMbi ||
        prevState?.data?.proposedEffDate != this?.state?.data?.proposedEffDate)
    ) {
      if (
        this?.state?.mandatoryMbi?.length >= 11 &&
        this?.state?.data?.proposedEffDate != "" &&
        this?.state?.proposedvalid === true &&
        moment(this?.state?.data?.proposedEffDate, "MM/DD/YYYY", true).isValid()
      ) {
        if (this?.props?.pendingApplFlag === false) {
          this.mbiFunc();
        } else {
          if (this?.props?.pendingApplFlag === true && this?.mbiFlag > 0) {
            this.mbiFunc();
          } else {
            this.mbiFlag = 1;
          }
        }
      }
    }
    if (
      prevState.data.permanentCounty &&
      prevState.data.permanentCounty != this.state.data.permanentCounty
    ) {
      let filteredCity = this.props.cityList.filter(
        (city) =>
          city.countyName.trim() === this.state?.data?.permanentCounty?.trim()
      );
      await this.setState({
        filteredCity: filteredCity,
      });

      if (filteredCity?.length === 1) {
        await this.setState({
          ...this.state,
          data: { ...this.state.data, permanentCity: filteredCity[0].cityName },
        });
        if (this.state.data.mailingAddressRequired === "YES") {
          await this.setState({
            ...this.state,
            data: { ...this.state.data, mailingCity: filteredCity[0].cityName },
          });
        }
      }
    }
    // let prevPayload = JSON.stringify(this.getData(prevState));
    // let currentPayload = JSON.stringify(this.getData(this.state));

    /*the below if and if else are for captcha functionality*/
    // if (
    //   this.props?.guestLogin === true &&
    //   this.props.isCaptchaValidated &&
    //   this.progress === 100 &&
    //   prevPayload !== currentPayload
    // ) {
    //   await this.props.captchaValidation(false);
    // }
  }
  static getDerivedStateFromProps(props, state) {
    let updateState = { ...state };
    if (state.data.premiumType === "D") {
      // return {
      //   ...state,
      //   data: {
      //     ...state.data,
      //     monthlybenefitsfrom: "",
      //   },
      // };
      updateState = {
        ...updateState,
        data: {
          ...state.data,
          monthlybenefitsfrom: "",
        },
      };
    }
    if (state.data.premiumType === "S" || state.data.premiumType === "R") {
      // return {
      //   ...state,
      //   data: {
      //     ...state.data,
      //     premiumType: "A",
      //     monthlybenefitsfrom: state.data.premiumType,
      //   },
      // };
      updateState = {
        ...updateState,
        data: {
          ...state.data,
          premiumType: "A",
          monthlybenefitsfrom: state.data.premiumType,
        },
      };
    }

    if (props.prospectEnroll && props.prospectflag && props.loadApi === false) {
      props.setStateParams("prospectflag", false);
      // let prospectDetail = props.prospectTableData.filter(
      //   (p) => p.leadIdNbr === props.leadIdNbr
      // )[0];
      // updateState={...updateState,data: {
      //   ...state.data,
      //   firstName: prospectDetail?.firstName,
      //   lastName: prospectDetail?.lastName,
      //   middleInitial: prospectDetail?.middleInitial,
      //   birthDate: prospectDetail?.dob,
      //   sex: prospectDetail?.gender,
      //   primaryPhoneNum: prospectDetail?.phoneNumber,
      //   medicareNumber:
      //     prospectDetail?.mbi === null ? "" : prospectDetail?.mbi,
      //   alternatePhone: props.demographicsData?.cellPhone,
      //   permanentCity: props.demographicsData?.city,
      //   emailAddress: props.demographicsData?.emailAddress,
      //   permanentAddrStreet: props.demographicsData?.primaryAddress1,
      // }}
    }
    if (
      props.preEnrollInfo &&
      props.pendingApplFlag === true &&
      state.formatphone === true
    ) {
      let qsnsdt = "";
      if (props.preEnrollInfo?.attestationList !== undefined) {
        qsnsdt = props.preEnrollInfo?.attestationList[1]?.answer;
      }
      let dateIndicator = props.preEnrollInfo?.attestationList?.filter((x) => {
        return x.answer !== "yes";
      });

      let arr = [];
      for (let i = 0; i < dateIndicator?.length; i++) {
        arr.push({ dateInd: "y" });
      }
      let pcpAddr = props.pendingApplFlag
        ? props.preEnrollInfo.pcpDetails?.address
        : props.pcpSelected?.pcpAddress;
      let pcpNm = props.pendingApplFlag
        ? props.preEnrollInfo.pcpName
        : props.pcpSelected.pcpName;
      let applCategory = "";
      applCategory = props.preEnrollInfo?.applcat
        ? props.preEnrollInfo?.applcat
        : "";
      //  === "E-ENROLL AGENT"
      //   ? "E-ENROLL AGENT"
      //   : props.preEnrollInfo?.applcat === "E-ENROLL TELEPHONE"
      //   ? "E-ENROLL TELEPHONE"
      //   : "";
      // let agentSign=props.preEnrollInfo.attachmentList && props.preEnrollInfo.attachmentList?.length>0 && props.preEnrollInfo.attachmentList.some((a)=>a.attachmentType==="SIGNATURE")
      // ?props.preEnrollInfo.attachmentList.filter((a1)=>a1.attachmentType==="SIGNATURE")[0]?.sign
      // :""
      // return {
      //   ...state,
      //   formatphone: false,
      //   attestationList: props.preEnrollInfo?.attestationList,
      //   dateInd: arr,
      //   data: {
      //     ...state.data,

      //     questionDate: qsnsdt,
      //     pcpName: pcpNm,
      //     pcpAddr: pcpAddr,
      //     applcat: applCategory === undefined ? "" : applCategory,
      //   },
      // };
      updateState = {
        ...updateState,
        formatphone: false,
        attestationList: props.preEnrollInfo?.attestationList,
        dateInd: arr,
        data: {
          ...state.data,

          questionDate: qsnsdt,
          pcpName: pcpNm,
          pcpAddr: pcpAddr,
          applcat: applCategory === undefined ? "" : applCategory,
          // agentSign:agentSign,
        },
      };
    }
    if (
      props.pendingApplFlag === true &&
      state.setPCP === true &&
      props.physiciansData.length > 1
    ) {
      let pcp = props.physiciansData.filter(
        (p) => p.label === props.preEnrollInfo.pcpName
      )[0];
      // return {
      //   ...state,
      //   setPCP: false,
      //   data: {
      //     ...state.data,
      //     pcpName: pcp?.value ? pcp.value : "",
      //   },
      // };
      updateState = {
        ...updateState,
        setPCP: false,
        data: {
          ...state.data,
          pcpName: pcp?.value ? pcp.value : "",
        },
      };
    }
    if (Object.keys(props.preEnrollInfo).length === 0) {
      // return {
      //   ...state,
      //   data: {
      //     ...state.data,
      //   },
      // };
      updateState = {
        ...updateState,
        data: {
          ...state.data,
        },
      };
    }
    return updateState;
  }
  handleChangeCategory = (name) => (event) => {
    let value = "";
    value = event.target ? event.target.value : event.value;
    if (name === "applcat" && this.props.customerId === VERDA_CONSTS.ID) {
      this.setState({
        ...this.state,
        data: { ...this.state.data, name: "", verbiage: "", [name]: value },
      });
      // }
      return;
    }
    this.setState((prevState) => ({
      ...prevState,
      data: { ...prevState.data, [name]: value },
    }));
  };

  PhoneNumberFormatter = () => {
    if (Object.keys(this.props.preEnrollInfo).length > 0) {
      let primarynumber = this.props.preEnrollInfo.primaryPhoneNum;
      if (this.props.preEnrollInfo.primaryPhoneNum?.length === 10) {
        primarynumber =
          "(" +
          this.props.preEnrollInfo.primaryPhoneNum?.slice(0, 3) +
          ") " +
          this.props.preEnrollInfo.primaryPhoneNum?.slice(3, 6) +
          "-" +
          this.props.preEnrollInfo.primaryPhoneNum?.slice(6, 10);
      }
      let cellnumber = this.props.preEnrollInfo.cellPhoneNum;
      if (this.props.preEnrollInfo.cellPhoneNum?.length === 10) {
        cellnumber =
          "(" +
          this.props.preEnrollInfo.cellPhoneNum?.slice(0, 3) +
          ") " +
          this.props.preEnrollInfo.cellPhoneNum?.slice(3, 6) +
          "-" +
          this.props.preEnrollInfo.cellPhoneNum?.slice(6, 10);
      }
      let authrepnumber = this.props.preEnrollInfo.phoneNumberOfRep;
      if (this.props.preEnrollInfo.phoneNumberOfRep?.length === 10) {
        authrepnumber =
          "(" +
          this.props.preEnrollInfo.phoneNumberOfRep?.slice(0, 3) +
          ") " +
          this.props.preEnrollInfo.phoneNumberOfRep?.slice(3, 6) +
          "-" +
          this.props.preEnrollInfo.phoneNumberOfRep?.slice(6, 10);
      }
      this.setState({
        data: {
          ...this.state.data,
          primaryPhoneNum: primarynumber,
          cellPhoneNum: cellnumber,
          phoneNumberOfRep: authrepnumber,
        },
      });
    }
  };
  handleDropdown = (name) => (event) => {
    let value = "";
    if (name === "pcpName") {
      value = event?.value;
    } else {
      value = event.target ? event.target.value : event.value || event.label;
    }
    this.setState({
      ...this.state,
      data: { ...this.state.data, [name]: value },
    });

    let selectedPCP = this.props.physiciansData.filter(
      (x) => x.doctorName + " " + "-" + " " + x?.locationId === value
    )[0];

    const payload = {
      pcpOfficeCd: selectedPCP.providerCode,
      PcpLocationId: selectedPCP.locationId,
      pcpName: selectedPCP.doctorName ? selectedPCP.doctorName : "no",
      pcpCurrPatnt: selectedPCP.currentPatientInd,
      pcpOffCatCd: selectedPCP.providerCategoryCode,
      pcpNpiId: selectedPCP.alternateOfficeCode,
      pcpAddress: selectedPCP.doctorAddress,
      pcpCity: selectedPCP.city,
      pcpState: selectedPCP.stateCode,
      pcpZip: selectedPCP.zipCode,
      distance: selectedPCP.googleApiDistance,
    };
    this.props.setPcpData(payload);
  };
  savePdfBlobs = (info) => {
    let final = this.state.data.pdfBlobs.filter(
      (f) => f.attachmentType !== info[0].attachmentType
    );
    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        pdfBlobs: [...final, ...info],
      },
    });
  };
  render() {
    const {
      // selectedPlan,
      snackBarOpen,
      severity,
      alertMsg,
      vertical,
      horizontal,
    } = this.state;
    let careIndFlag =
      this.props.customerId !== VERDA_CONSTS.ID
        ? true
        : this.state.data.careInd === "Y";
    let cardioVascularFlag =
      this.props.customerId !== VERDA_CONSTS.ID
        ? true
        : this.props.productId === "TX2B" ||
          this.state.data?.productId === "TX2B"
        ? this.state.data.cardioVascular === "Y"
        : true;
    let count = "";
    if (
      //   this.props.year.planYear === "2023" ||
      //   this.props?.year === "2023" ||
      //   this.props?.year === "2024"
      this.props.year.planYear ||
      this.props?.year
    ) {
      // count = this.state.data.mailingAddressRequired === "YES" ? 44 : 40;
      count = 40;
      // let progress32, progress33, progress34, progress40;
      // if (this.state.data.mailingAddressRequired === "YES") {
      //  progress32 = this.state.data.mailingCity === "" ? 0 : 1;
      //  progress33 = this.state.data.mailingAddr === "" ? 0 : 1;
      //  progress34 = this.state.data.mailingzip === "" ? 0 : 1;
      //   progress40 = this.state.data.mailingState === "" ? 0 : 1;
      // }
      let progress52 = 0;
      if (this.props.customerId === NEBRASKA_CONSTS.ID) {
        //Adding progress for Nebraska customer
        count += 5;
        let progress32,
          progress33,
          progress34,
          progress40,
          premium1,
          premium2,
          premium3,
          premium4,
          premium5;
        progress32 = this.state.data.mailingCity === "" ? 0 : 1;
        progress33 = this.state.data.mailingAddr === "" ? 0 : 1;
        progress34 = this.state.data.mailingzip === "" ? 0 : 1;
        progress40 = this.state.data.mailingState === "" ? 0 : 1;
        premium5 = this.state?.data?.premiumType === "" ? 0 : 1;

        if (this.state?.data?.premiumType === "W") {
          count += 4;
          premium1 = this.state.data.acctholdername === "" ? 0 : 1;
          premium2 = this.state.data.routingNumber === "" ? 0 : 1;
          premium3 = this.state.data.accountNumber === "" ? 0 : 1;
          premium4 = this.state.data.acctType === "" ? 0 : 1;
          progress52 =
            progress32 +
            progress33 +
            progress34 +
            progress40 +
            premium1 +
            premium2 +
            premium3 +
            premium4 +
            premium5;
        } else {
          progress52 =
            progress32 + progress33 + progress34 + progress40 + premium5;
        }
      }

      const progress1 =
        this.state.data?.firstName === "" ||
        this.state.data?.firstName === undefined
          ? 0
          : 1;
      const progress2 =
        this.state.data?.lastName === "" ||
        this.state.data?.lastName === undefined
          ? 0
          : 1;
      const progress3 =
        this.state.data.birthDate === "" ||
        !moment(this.state.data.birthDate, "MM/DD/YYYY", true).isValid()
          ? 0
          : 1;

      const progress4 =
        this.state.data.primaryPhoneNum === "" ||
        this.state.data.primaryPhoneNum?.length < 10
          ? 0
          : 1;
      const progress5 =
        this.state.data.permanentAddrStreet === "" ||
        poArray.some((pos1) =>
          this.state.data.permanentAddrStreet?.startsWith(pos1)
        )
          ? 0
          : 1;
      const progress6 = this.state.data.permanentCity === "" ? 0 : 1;

      const progress7 = this.props.deeplink
        ? this.props.dpzipCode === "" && this.state.data.permanentZip === ""
          ? 0
          : 1
        : this.props.zipCode === "" && this.state.data.permanentZip === ""
        ? 0
        : 1;
      const progress8 =
        this.state.data.sex === "" || this.state.data.sex === undefined ? 0 : 1;
      const progress9 =
        this.state.data.medicareNumber === "" ||
        this.state.data.medicareNumber === undefined ||
        this.state.mandatoryMbi.length < 11
          ? 0
          : 1;
      // let signFlag=this.props.pendingApplFlag===false?
      // this.state.data.agentSign === ""?0:1
      // :this.state.data?.attachmentList?.length>0
      // ?this.state.data.attachmentList.some((a1)=>a1.attachmentType==="SIGNATURE")
      // :true
      const progress12 =
        this.state.data?.applcat !== "" &&
        this.state.data?.applcat !== undefined &&
        this.props.agentLogin === true
          ? this.state.data?.applcat === "E-ENROLL TELEPHONE" ||
            this.state.data?.applcat === "E-ENROLL PAPER"
            ? this.state.data.name === ""
              ? 0
              : 1
            : this.state.data?.applcat === "E-ENROLL AGENT"
            ? this.state.data.agentSign === ""
              ? 0
              : 1
            : 0
          : this.state.data.name === ""
          ? 0
          : 1;

      const progress13 =
        this.state.data.isAuthRepresentative === "Y" &&
        this.state.data.nameOfRep !== ""
          ? 1
          : 0;
      const progress44 =
        this.state.data.isAuthRepresentative === "Y" &&
        this.state.data.lastNameOfRep !== ""
          ? 1
          : 0;
      const progress45 =
        this.state.data.isAuthRepresentative === "Y" &&
        this.state.data.authRepCity !== ""
          ? 1
          : 0;
      const progress46 =
        this.state.data.isAuthRepresentative === "Y" &&
        this.state.data.authRepState !== ""
          ? 1
          : 0;
      const progress47 =
        this.state.data.isAuthRepresentative === "Y" &&
        this.state.data.authRepZip !== "" &&
        this.state.data.authRepZip?.length === 5
          ? 1
          : 0;

      const progress49 =
        this.state.data.emailOptionIndicator === "Y"
          ? this.state.data.emailAddress === "" ||
            this.validator.check(this.state.data.emailAddress, "email") ===
              false
            ? 0
            : 1
          : 0;
      const progress50 =
        this.state.data?.ltcInd === "Y"
          ? this.state.data?.nameOfInstitution !== "" &&
            this.state.data?.nameOfInstitution !== undefined &&
            this.state.data?.nameOfInstitution !== "---SELECT---"
            ? this.state.data?.addrOfInstitution !== "" &&
              this.state.data?.addrOfInstitution !== undefined
              ? 1
              : 0
            : 0
          : 0;
      const progress14 =
        this.state.data.isAuthRepresentative === "Y" &&
        this.state.data.relationOfRep !== ""
          ? 1
          : 0;
      const progress15 =
        this.state.data.isAuthRepresentative === "Y" &&
        this.state.data.addressOfRep !== ""
          ? 1
          : 0;
      const progress16 =
        this.state.data.isAuthRepresentative === "Y" &&
        this.state.data?.phoneNumberOfRep !== "" &&
        this.state.data?.phoneNumberOfRep?.length === 14
          ? 1
          : 0;
      let progress17 = this.state.data.isLicensedSalesRep === "Y" ? 1 : 0;
      const progress35 =
        this.state.data.isDrugCoverage === "Y" &&
        this.state.data.nameOfCoverage !== ""
          ? 1
          : 0;
      const progress36 =
        this.state.data.isDrugCoverage === "Y" &&
        this.state.data.covMemberNumber !== ""
          ? 1
          : 0;
      const progress37 =
        this.state.data.isDrugCoverage === "Y" &&
        this.state.data.covGroupNumber !== ""
          ? 1
          : 0;
      const progress18 =
        this.state.data.c2 === "MOV" && this.state.data.attestation2 !== ""
          ? 1
          : 0;
      const progress19 =
        this.state.data.c3 === "INC" && this.state.data.attestation3 !== ""
          ? 1
          : 0;
      const progress20 =
        this.state.data.c4 === "RUS" && this.state.data.attestation4 !== ""
          ? 1
          : 0;
      const progress21 =
        this.state.data.c5 === "LAW" && this.state.data.attestation5 !== ""
          ? 1
          : 0;
      const progress22 =
        this.state.data.c8 === "NLS" && this.state.data.attestation8 !== ""
          ? 1
          : 0;
      const progress23 =
        this.state.data.c9 === "LTC" && this.state.data.attestation9 !== ""
          ? 1
          : 0;
      const progress24 =
        this.state.data.c10 === "PAC" && this.state.data.attestation10 !== ""
          ? 1
          : 0;
      const progress25 =
        this.state.data.c11 === "LCC" && this.state.data.attestation11 !== ""
          ? 1
          : 0;
      const progress26 =
        this.state.data.c12 === "LEC" && this.state.data.attestation12 !== ""
          ? 1
          : 0;
      const progress27 =
        this.state.data.c15 === "SNP" && this.state.data.attestation15 !== ""
          ? 1
          : 0;
      const progress28 =
        this.state.data.c22 === "MCD" &&
        this.state.data.recentlyChangeMedicaid !== ""
          ? 1
          : 0;
      const progress29 =
        this.state.data.c7 === "HLP" && this.state.data.attestation7;
      let progress38 = 0;

      const progress48 =
        this.state.data.proposedEffDate === "" ||
        this.state?.proposedvalid === false ||
        !moment(this.state.data.proposedEffDate, "MM/DD/YYYY", true).isValid()
          ? 0
          : 1;
      const progress41 =
        this.props.customerId !== ILS_CONSTS.ID &&
        (this.state.data.partAEffDate === "" ||
          this.state?.partAvalid === false) &&
        !moment(this.state.data.partAEffDate, "MM/DD/YYYY", true).isValid()
          ? 0
          : this.props.customerId === ILS_CONSTS.ID &&
            this.state.data.partAEffDate !== "" &&
            !moment(this.state.data.partAEffDate, "MM/DD/YYYY", true).isValid()
          ? 0
          : 1;
      const progress42 =
        this.props.customerId !== ILS_CONSTS.ID &&
        (this.state.data.partBEffDate === "" ||
          this.state?.partBvalid === false ||
          !moment(this.state.data.partBEffDate, "MM/DD/YYYY", true).isValid())
          ? 0
          : this.props.customerId === ILS_CONSTS.ID &&
            this.state.data.partBEffDate !== "" &&
            !moment(this.state.data.partBEffDate, "MM/DD/YYYY", true).isValid()
          ? 0
          : 1;
      const progress43 =
        this.state.data.medicaidInd === "Y" && this.state.data.medicaidId !== ""
          ? 1
          : 0;
      // const progress51 =this.props.product != "PDP"?
      //   this.props.planType === "HMO"
      //     ? this.props.pendingApplFlag === false
      //       ? (this.props.pcpSelected?.pcpName === "" ||
      //         this.props.pcpSelected?.pcpName === undefined)
      //         ? 0
      //         : 1
      //       : this.state.data.pcpName === "" &&
      //         this.props.preEnrollInfo.pcpName === "" &&
      //         (this.props.pcpSelected?.pcpName === "" ||
      //           this.props.pcpSelected?.pcpName === undefined)
      //       ? 0
      //       : 1
      //     : 0
      //     :1;
      const progress51 =
        this.props.product != "PDP"
          ? this.props.planType === "HMO"
            ? (this.props?.pcpSelected?.pcpName != "" &&
                this.props.pcpSelected?.pcpName != undefined) ||
              (this.state?.data?.pcpName != "" &&
                this.state.data?.pcpName != undefined) ||
              (this.props.preEnrollInfo?.pcpName != "" &&
                this.props.preEnrollInfo?.pcpName != undefined)
              ? 1
              : 0
            : 0
          : 1;

      const subQnfilled = this.state?.questionDate.filter((qsn) => {
        return moment(qsn.answer, "MM/DD/YYYY", true).isValid() === true;
      });
      let isExist = this.state?.dateInd.filter((u) => {
        return u?.dateInd === "y";
      });
      const dates = {
        attestation2: this.state.data.attestation2,
        attestation3: this.state.data.attestation3,
        attestation4: this.state.data.attestation4,
        attestation5: this.state.data.attestation5,
        attestation7: this.state.data.attestation7,
        attestation8: this.state.data.attestation8,
        attestation9: this.state.data.attestation9,
        attestation10: this.state.data.attestation10,
        attestation11: this.state.data.attestation11,
        attestation12: this.state.data.attestation12,
        attestation15: this.state.data.attestation15,
        recentlyChangeMedicaid: this.state.data.recentlyChangeMedicaid,
      };
      let count1 = 0;
      Object.keys(dates).map((key) => {
        // if (dates[key] !== "" && dates[key] !== undefined) { SONAR fix
        //   if (moment(dates[key], "MM/DD/YYYY", true).isValid() === false) {

        //   }
        // } else {
        ++count1;
        // }
      });

      count -= 12;

      if (this.state.data.termsAndConditions !== "Y") count += 1;
      if (this.state.data.isAuthRepresentative !== "Y") count -= 8;
      if (this.state.data.medicaidInd != "Y") count -= 1;
      if (this.state.data.isLicensedSalesRep !== "Y") count -= 1;
      if (this.state.data.isDrugCoverage !== "Y") count -= 1;
      if (this.state.data.isDrugCoverage == "Y") count += 2;
      if (isExist?.length === 0) count = count - 1;
      if (this.props.product != "PDP" && this.props.planType !== "HMO") {
        count -= 1;
      }
      if(this.state.data.isLicensedSalesRep === "Y" && this.state.data.salRepName === ""){
        progress17 = 0;
      }
      if (
        subQnfilled?.length === this.state.questionDate.length &&
        this.state.questionDate?.length > 0 &&
        this.state.questionDate.length === isExist?.length
      ) {
        progress38 = 1;
      }
      if (
        (this.state?.data?.premiumType === "A" ||
          this.state?.data?.premiumType === "S" ||
          this.state?.data?.premiumType === "R") &&
        (this.state.data?.monthlybenefitsfrom == "" ||
          this.state.data?.monthlybenefitsfrom == undefined)
      )
        count += 1;

      if (this.state.data.emailOptionIndicator !== "Y") count -= 1;
      if (this.state.data?.ltcInd !== "Y") count -= 1;
      this.progress =
        ((progress1 +
          progress2 +
          progress3 +
          progress4 +
          progress5 +
          progress6 +
          progress7 +
          progress8 +
          progress9 +
          progress12 +
          progress13 +
          progress44 +
          progress45 +
          progress46 +
          progress47 +
          progress14 +
          progress15 +
          progress16 +
          progress17 +
          progress35 +
          progress36 +
          progress37 +
          progress18 +
          progress19 +
          progress20 +
          progress21 +
          progress22 +
          progress23 +
          progress24 +
          progress25 +
          progress26 +
          progress27 +
          progress28 +
          progress29 +
          progress38 +
          progress41 +
          progress42 +
          progress43 +
          progress48 +
          progress49 +
          progress50 +
          progress51 +
          progress52) /
          // (this.state.data.mailingAddressRequired === "YES"
          //   ? progress32 + progress33 + progress34 + progress40
          //   : 0)
          count) *
        100;
      // console.log("clsprogress",this.progress,"pcp",progress51,"count",count,"plantype",this.props.planType,"pendingflag",this.props.pendingApplFlag)
      // console.log("clspcpselectedpcpname",this.props.pcpSelected?.pcpName,"statepcp",this.state.data.pcpName,"preenrolpcp",this.props.preEnrollInfo.pcpName)
    }
    return (
      <React.Fragment>
        <div class="background stepper-form-aligner">
          <Snackbar
            open={snackBarOpen}
            autoHideDuration={6000}
            onClose={this.handleClose}
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
          >
            <Alert onClose={this.handleClose} severity={severity}>
              {alertMsg}
            </Alert>
          </Snackbar>

          <StepperSidebar
            agentLogin={this.props.agentLogin}
            stepVal={this.state.stepVal}
            handleSteps={this.handleSteps}
            productName={this.props.productName}
            // setSideBar={(show)=>this.setState({...this.state,isStepBar:show})}
          />
          <div class="mt-3 form-container">
            <div className="ml-4 mr-3">
              <div class="display-flex jcsp container-Cambia">
                <div class="row w-100">
                  <div class="col-lg-9 col-md-12">
                    <h4>
                      {this.props.planName
                        ? this.props.planName
                        : this.props.preEnrollInfo?.planName}
                    </h4>
                  </div>
                  {this.props.isUpdated === false && (
                    <div class="col-lg-3 col-md-12 padding-bottom-10px">
                      <button
                        onClick={this.changePlan}
                        class="btn btn-secondary-enroll ml-10"
                      >
                        <Text id="app.cngPln" />
                      </button>
                    </div>
                  )}
                  {this.props.isUpdated ? (
                    <div class="col-lg-3 col-md-12 padding-bottom-10px">
                      <button
                        onClick={this.goBack}
                        class="btn btn-secondary-enroll ml-10"
                      >
                        <Text id="app.dashboard" />
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div class="progress-bar">
                <LinearProgress
                  variant="determinate"
                  value={this.progress}
                  color="primary"
                  classes={{
                    root: this.props.classes.root,
                    barColorPrimary:
                      this.progress === 100
                        ? this.props.classes.progressComplete
                        : this.props.classes.progressIncomplete,
                  }}
                />
              </div>

              {/* <div
              class={
                !this.props.agentLogin
                  ? "div-list-aligner"
                  : "div-agent-list-aligner"
              }
            >
             
              <ul
                class={
                  !this.props.agentLogin
                    ? "nav nav-pills nav-justified list-aligner"
                    : "nav nav-pills nav-justified"
                }
                value={this.state.stepVal}
                onClick={this.handleSteps}
              >
                {this.props.agentLogin === true &&
                  this.props.productName !== "Medicare Supplement" && (
                    <li class="nav-item">
                      <p
                        class={
                          this.state.stepVal === "step0"
                            ? "nav-link active1"
                            : "nav-link header-steps"
                        }
                        data-toggle="tab"
                        id="step0"
                      >
                        <Text id="app.soa" />
                      </p>
                    </li>
                  )}
                <li class="nav-item">
                  <p
                    class={
                      this.state.stepVal === "step1"
                        ? "nav-link active1"
                        : "nav-link header-steps"
                    }
                    data-toggle="tab"
                    id="step1"
                  >
                    Personal Information
                  </p>
                </li>
                <li
                  class={
                    this.props.agentLogin
                      ? "nav-item attestation-details-aligner"
                      : "nav-item header-steps"
                  }
                >
                  <p
                    class={
                      this.state.stepVal === "step2"
                        ? "nav-link active1"
                        : "nav-link header-steps"
                    }
                    data-toggle="tab"
                    id="step2"
                  >
                    Attestation Details
                  </p>
                </li>
                <li class="nav-item other-details-aligner">
                  <p
                    class={
                      this.state.stepVal === "step3"
                        ? "nav-link active1"
                        : "nav-link header-steps"
                    }
                    data-toggle="tab"
                    id="step3"
                  >
                    Other Details
                  </p>
                </li>

                {this.props.agentLogin === true && (
                  <li class="nav-item preview-aligner">
                    <p
                      class={
                        this.state.stepVal === "step4"
                          ? "nav-link active1"
                          : "nav-link header-steps"
                      }
                      data-toggle="tab"
                      id="step4"
                    >
                      Preview
                    </p>
                  </li>
                )}
                {this.props.agentLogin === true && (
                  <li class="nav-item preview-aligner">
                    <p
                      class={
                        this.state.stepVal === "step5"
                          ? "nav-link active1"
                          : "nav-link header-steps"
                      }
                      data-toggle="tab"
                      id="step5"
                    >
                      Signature
                    </p>
                  </li>
                )}
              </ul>
            </div> */}
              {this.state.stepVal === "step0" &&
                this.props.productName !== "Medicare Supplement" && (
                  <Soa
                    // handleMutipleCheckbox={this.handleMutipleCheckbox}
                    data={this.state.data}
                    redirect={this.redirect}
                    authorizedrelations={this.props.authorizedrelations}
                    isSoaFilled={this.state.isSoaFilled}
                  />
                )}
              {this.state.stepVal === "step1" && (
                <Step1
                  OnBlurpermananentZip4={this.OnBlurpermananentZip4}
                  OnBlurauthZip4={this.OnBlurauthZip4}
                  OnBlurmailZip4={this.OnBlurmailZip4}
                  partAvalid={this.state.partAvalid}
                  partBvalid={this.state.partBvalid}
                  proposedvalid={this.state.proposedvalid}
                  filteredCity={this.state.filteredCity}
                  selectedPlan={this.props.selectedPlan}
                  data={this.state.data}
                  handleNumberChange={this.handleNumberChange}
                  authorizedrelations={this.props.authorizedrelations}
                  handleChange={this.handleChange}
                  handleSuggestion={this.handleSuggestion}
                  handlePermanentAddresses={this.handlePermanentAddresses}
                  redirect={this.redirect}
                  handleDates={this.handleDates}
                  handleDate={this.handleDate}
                  handleDateNew={this.handleDateNew}
                  handleReqEffDates={this.handleReqEffDates}
                  handleCheckbox={this.handleCheckbox}
                  handleCheckbox2={this.handleCheckbox2}
                  checkEligibility={this.checkEligibility}
                  formDisable={this.props.formDisable}
                  agentLogin={this.props.agentLogin}
                  productName={this.props.productName}
                  handleEffDates={this.handleEffDates}
                  mandatoryMbi={this.state.mandatoryMbi}
                  salesreplist={this.props.salesreplist}
                />
              )}

              {this.state.stepVal === "step2" &&
                (this.props.productName !== "Medicare Supplement" ? (
                  <Step2
                    pcpChange={this.pcpChange}
                    selectedPlan={this.props.selectedPlan}
                    data={this.state.data}
                    handleCheckbox={this.handleCheckbox}
                    handleQuestionId={this.handleQuestionId}
                    redirect={this.redirect}
                    disableCheck={this.state.disableCheck}
                    handleChange={this.handleChange}
                    // handleDates={this.handleDates}
                    // handleDateAttestation={this.handleDateAttestation}
                    // handleDatesAttestation={this.handleDatesAttestation}
                    qsnsDate={this.qsnsDate}
                    questionDate={this.state.questionDate}
                    handleDate={this.handleDate}
                    attestationList={this.state.attestationList}
                    setQSNS={this.setQSNS}
                    //setDateInd={this.setDateInd}
                    handleAttestationDate={this.handleAttestationDate}
                  />
                ) : (
                  <Step2Med
                    data={this.state.data}
                    handleChange={this.handleChange}
                    handleDates={this.handleDates}
                    handleDate={this.handleDate}
                    redirect={this.redirect}
                  />
                ))}

              {this.state.stepVal === "step3" && (
                <Step3
                  pcpName={
                    this.props.pcpSelected.pcpName
                      ? this.props.pcpSelected.pcpName
                      : ""
                  }
                  PcpLocationId={
                    this.props.pcpSelected.PcpLocationId != undefined &&
                    this.props.pcpSelected.PcpLocationId != ""
                      ? this.props.pcpSelected.PcpLocationId
                      : this.props?.preEnrollInfo?.locationId
                      ? this.props?.preEnrollInfo?.locationId
                      : ""
                  }
                  openSnackBar={(msg, type) =>
                    this.setState({
                      snackBarOpen: true,
                      alertMsg: msg,
                      severity: type,
                    })
                  }
                  savePdfBlobs={this.savePdfBlobs}
                  selectedPlan={this.props.selectedPlan}
                  data={this.state.data}
                  url={this.state.viewurl}
                  handleChange={this.handleChange}
                  handleNumberChange={this.handleNumberChange}
                  pcpChange={this.pcpChange}
                  redirect={this.redirect}
                  handleDates={this.handleDates}
                  handleDate={this.handleDate}
                  handleCheckbox={this.handleCheckbox}
                  handleCheckbox2={this.handleCheckbox2}
                  formDisable={this.props.formDisable}
                  agentLogin={this.props.agentLogin}
                  clearFiles={() => {
                    this.setState((prevState) => ({
                      ...prevState,
                      selectedFiles: [],
                    }));
                  }}
                  selectedFiles={this.state.selectedFiles}
                  removeFile={this.removeFile}
                  viewFile={this.viewFile}
                  fileType={this.state.fileType}
                  typeOfFilesToUpload={this.props?.typeOfFilesToUpload}
                  saveSign={this.saveSign}
                  clear={this.clear}
                  setSnackBar={this.setSnackBar}
                  productName={this.props.productName}
                  handleRaceAndEthic={this.handleRaceAndEthic}
                  email={this.state.data.emailAddress}
                  filterDeletedSignature={() => {
                    let attchLst = this.state.data.attachmentList?.filter(
                      (lst) => lst?.attachmentType !== "SIGNATURE"
                    );
                    this.setState({
                      ...this.state,
                      data: {
                        ...this.state.data,
                        attachmentList: attchLst,
                        agentSign: "",
                      },
                    });
                  }}
                  OnBlurEmailAddr={this.OnBlurEmailAddr}
                  // makePcpEmpty={()=>this.setState({...this.state,data:{...this.state.data,pcpName:""}})}
                  handleDropdown={this.handleDropdown}
                  cardioVascularHandler={(data4) =>
                    this.setState({
                      ...this.state,
                      data: { ...this.state.data, ...data4 },
                    })
                  }
                  careIndHandler={(data5) =>
                    this.setState({
                      ...this.state,
                      data: { ...this.state.data, ...data5 },
                    })
                  }
                />
              )}

              {this.state.stepVal === "step4" && (
                <Step4Agent
                  selectedAttestation={this.state.attestationList}
                  url={this.state.viewurl}
                  viewFile={this.viewFile}
                  authorizedrelations={this.props.authorizedrelations}
                  physicians={this.props.physicians}
                  productName={this.props.productName}
                  uploadFiles1={this.uploadFiles}
                  saveSign={this.saveSign}
                  clear={this.clear}
                  fileType={this.state.fileType}
                  planName={this.props.planName || this.state.data.planName}
                  pcpName={
                    this.props.pcpSelected.pcpName
                      ? this.props.pcpSelected.pcpName
                      : ""
                  }
                  PcpLocationId={
                    this.props.pcpSelected.PcpLocationId != undefined &&
                    this.props.pcpSelected.PcpLocationId != ""
                      ? this.props.pcpSelected.PcpLocationId
                      : this.props?.preEnrollInfo?.locationId
                      ? this.props?.preEnrollInfo?.locationId
                      : ""
                  }
                  // changeSection={() => {
                  //   this.setState((prevState) => ({
                  //     ...prevState,
                  //     stepVal: "step1",
                  //   }));
                  // }}
                  changeToSection1={() => {
                    this.setState((prevState) => ({
                      ...prevState,
                      stepVal: "step1",
                    }));
                  }}
                  changeToSection2={() => {
                    this.setState((prevState) => ({
                      ...prevState,
                      stepVal: "step2",
                    }));
                  }}
                  changeToSection3={() => {
                    this.setState((prevState) => ({
                      ...prevState,
                      stepVal: "step3",
                    }));
                  }}
                  clearFiles={() => {
                    this.setState((prevState) => ({
                      ...prevState,
                      selectedFiles: [],
                    }));
                  }}
                  data={this.state.data}
                  selectedFiles={this.state.selectedFiles}
                  handleChange={this.handleChange}
                  removeFile={this.removeFile}
                  redirect={this.redirect}
                  //authorizedrelations={this.props.authorizedrelations}
                  handleDates={this.handleDates}
                  handleDate={this.handleDate}
                  typeOfFilesToUpload={this.props.typeOfFilesToUpload}
                  Soa={this.state.SOA}
                  handleChangeCategory={this.handleChangeCategory}
                  openSnackBar={(msg, type) =>
                    this.setState({
                      snackBarOpen: true,
                      alertMsg: msg,
                      severity: type,
                    })
                  }
                />
              )}
              {this.state.stepVal === "step5" && (
                <Step5Agent
                  url={this.state.viewurl}
                  viewFile={this.viewFile}
                  authorizedrelations={this.props.authorizedrelations}
                  physicians={this.props.physicians}
                  productName={this.props.productName}
                  uploadFiles1={this.uploadFiles}
                  saveSign={this.saveSign}
                  clear={this.clear}
                  fileType={this.state.fileType}
                  planName={this.props.planName}
                  pcpName={this.props.pcpSelected.pcpName}
                  changeSection={() => {
                    this.setState((prevState) => ({
                      ...prevState,
                      stepVal: "step1",
                    }));
                  }}
                  clearFiles={() => {
                    this.setState((prevState) => ({
                      ...prevState,
                      selectedFiles: [],
                    }));
                  }}
                  data={this.state.data}
                  selectedFiles={this.state.selectedFiles}
                  handleChange={this.handleChange}
                  removeFile={this.removeFile}
                  redirect={this.redirect}
                  //authorizedrelations={this.props.authorizedrelations}
                  handleDates={this.handleDates}
                  handleDate={this.handleDate}
                  typeOfFilesToUpload={this.props.typeOfFilesToUpload}
                  Soa={this.state.SOA}
                  handleChangeCategory={this.handleChangeCategory}
                  filterDeletedSignature={() => {
                    // let flag = false;
                    // if (flag) {
                    let attchLst = this.state.data.attachmentList?.filter(
                      (lst) => lst?.attachmentType !== "SIGNATURE"
                    );
                    this.setState({
                      ...this.state,
                      data: { ...this.state.data, attachmentList: attchLst },
                    });
                    // }
                  }}
                  getData={() => this.getData(this.state)}
                  attestationSelected={this.state?.attestationList}
                  selectedQnId={this.state?.selectedQnId}
                />
              )}
              {/* {this.props?.guestLogin === true &&
              this.progress === 100 &&
              !this.props.isCaptchaValidated &&
              this.props.preEnrollInfo?.appStatus !== "READY" &&
              this.props.preEnrollInfo?.appStatus !== "SUBMITTED" && (
                <div>
                  <Captcha />
                </div>
              )} */}
              {this.props.preEnrollInfo?.appStatus != "READY" &&
                this.props.preEnrollInfo?.appStatus != "SUBMITTED" && (
                  <div class="mt-3 d-flex align-item-center justify-content-between col-12">
                    <div class="mr-4 text-nowrap">
                      {!this.props.guestLogin ? (
                        <button
                          class="btn btn-SaveLogout"
                          id="submit"
                          onClick={this.saveData}
                          //disabled={this.props.formDisable}
                          disabled={
                            this.props?.Submitted ||
                            this.props.preEnrollInfo?.appStatus === "READY" ||
                            this.props.preEnrollInfo?.appStatus === "SUBMITTED"
                          }
                        >
                          <Text id="app.save" />
                        </button>
                      ) : null}
                    </div>
                    <div class="d-none d-md-block">
                      {this.progress != 100 ||
                      !validEmail ||
                      !cardioVascularFlag ||
                      !careIndFlag ||
                      (this.props.productId?.includes("DSN") &&
                      [ILS_CONSTS.ID].some(
                        (ids) => ids === this.props.customerId
                      )
                        ? this.state.data.medicaidInd !== "Y"
                          ? true
                          : false
                        : false) ? (
                        //  ||
                        // !this.props.isCaptchaValidated
                        <span class="small text-danger font-size-15px">
                          <strong>
                            <Text id="app.error1" />
                            {this.props.agentLogin
                              ? " steps 1-5 "
                              : " steps 1-3 "}
                            {/* {this.props?.guestLogin === true ? (
                        <Text id="app.captchaerror2" />
                      ) : ( */}
                            <Text id="app.error2" />
                            {/* )} */}
                          </strong>
                        </span>
                      ) : (
                        <span class="small text-success">
                          {this.props.customerId !== VERDA_CONSTS.ID ? (
                            <strong>
                              <Text id="app.cong" />.
                            </strong>
                          ) : (
                            <strong>
                              <Text id="app.congverda" />.
                            </strong>
                          )}
                        </span>
                      )}
                    </div>
                    <div class="ml-1">
                      <button
                        class={
                          this.progress === 100 &&
                          (this.props.productId?.includes("DSN") &&
                          [ILS_CONSTS.ID].some(
                            (ids) => ids === this.props.customerId
                          )
                            ? this.state.data.medicaidInd === "Y"
                              ? true
                              : false
                            : true)
                            ? // && cardioVascularFlag && careIndFlag
                              //&& this.props.isCaptchaValidated
                              "btn btn-primary float-right"
                            : "btn btn-secondary float-right"
                        }
                        id="submit"
                        onClick={this.submitData}
                        disabled={
                          !validEmail ||
                          this.props?.Submitted ||
                          this.props.preEnrollInfo?.appStatus === "READY" ||
                          this.props.preEnrollInfo?.appStatus === "SUBMITTED" ||
                          this.progress !== 100 ||
                          (this.props.productId?.includes("DSN") &&
                          [ILS_CONSTS.ID].some(
                            (ids) => ids === this.props.customerId
                          )
                            ? !(this.state.data.medicaidInd === "Y")
                            : false)
                          // ||
                          // !cardioVascularFlag || !careIndFlag
                          // ||
                          // !this.props.isCaptchaValidated
                          //  || this.props.formDisable
                        }
                      >
                        <Text id="app.submit" />
                      </button>
                    </div>
                  </div>
                )}
              <div class="d-md-none">
                {!validEmail ||
                this.progress != 100 ||
                (this.props.productId?.includes("DSN") &&
                [ILS_CONSTS.ID].some((ids) => ids === this.props.customerId)
                  ? this.state.data.medicaidInd !== "Y"
                    ? true
                    : false
                  : false) ? (
                  // ||
                  // !this.props.isCaptchaValidated
                  <span class="small text-danger font-size-15px">
                    <strong>
                      <Text id="app.error1" />
                      {this.props.agentLogin ? " steps 1-4 " : " steps 1-3 "}
                      {/* {this.props?.guestLogin === true ? (
                      <Text id="app.captchaerror2" />
                    ) : ( */}
                      <Text id="app.error2" />
                      {/* )} */}
                    </strong>
                  </span>
                ) : (
                  <span class="small text-success">
                    {this.props.customerId !== VERDA_CONSTS.ID ? (
                      <strong>
                        <Text id="app.cong" />.
                      </strong>
                    ) : (
                      <strong>
                        <Text id="app.congverda" />.
                      </strong>
                    )}
                  </span>
                )}
              </div>

              <br />

              <p class="planName-year">
                <strong>
                  {this.props.planName
                    ? this.props.planName
                    : this.state.data?.planName}
                  _{this.props.year.planYear}{" "}
                  {FieldLabel("online1", this.props.customerId)}
                </strong>
              </p>

              {this.props.year ? (
                <div class="form-footer footer-margin">
                  {FieldLabel("newfooter", this.props.customerId)}
                  {/* <Text id="app.newfooter" /> */}
                </div>
              ) : null}
            </div>
            {/* <div> */}
            <Footer
              matchFound={true}
              customerId={this.props.customerId}
              theme={this.props.theme}
            />
            {/* </div> */}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    electionType: state.webApp.electionType,
    agencyIDSelected: state.login.agencyIDSelected,
    soa: state.webApp.soa,
    year: state.webApp.year?.planYear
      ? state.webApp.year.planYear
      : state.webApp.year,
    preEnrollInfo: state.webApp.preEnrollInfo,
    guestLogin: state.login.guestLogin,
    authorizedrelations: state.webApp.authorizedrelations,
    selectedPlan: state.login.selectedPlan,
    selectedPlanId: state.login.selectedPlanId,
    planSelecteddetails: state.webApp.planSelected,
    planName: state.login.selectedPlanName,
    lang: state.webApp.language,
    productId: state.login.productId,
    product: state.webApp?.product ? state.webApp?.product : "",
    zipCode: state.webApp.zip,
    stateName: state.webApp.state,
    countyName: state.webApp.county,
    emailAddress: state.login.emailAddress,
    eligibleStatus: state.login.isEligible,
    isUpdated: state.webApp.isUpdated,
    formDisable: state.webApp.formDisable,
    agentLogin: state.login.agentLoggedIn,
    productName: state.login.selectedProductName,
    physicians: state.webApp.physicians,
    cardDetails: state.webApp.planCardData,
    premiumAmount: state.login.premiumAmount,
    agentId: state.login.agentId,
    stateCd: state.webApp.stateCd,
    selectedProductName: state.login.selectedProductName,
    authenticatedData: state.login.authenticatedData,
    deeplink: state.login.deeplink,
    dpcountyName: state.login.dpcountyName,
    dpzipCode: state.login.dpzipCode,
    dpProductId: state.login.dpProductId,
    pendingApplFlag: state.webApp.pendingApplFlag,
    CountyCd: state.webApp.CountyCd,
    physiciansData: state.webApp.physiciansData,
    token: state.login.token,
    prospectEnroll: state.webApp.prospectEnroll,
    SOAData: state.campaignProspect.SOAData,
    productIds: state.webApp.productIds,
    salesreplist:
      state.campaignProspect.salesreplist.length > 0
        ? state.campaignProspect.salesreplist
        : state.campaignProspect.agentList,
    prospectTableData: state.campaignProspect.prospectTableData,
    demographicsData: state.campaignProspect.demographicsData,
    leadIdNbr: state.campaignProspect.leadIdNbr,
    prospectrowData: state.campaignProspect.prospectrowData,
    prospectflag: state.webApp.prospectflag,
    loadApi: state.webApp.loadApi,
    stateId: state.webApp.stateId,
    ZipCodes: state.webApp.zipCodes,
    cityName: state.webApp.cityName,
    pcpSelected: state.webApp.selectedVo,
    qsns: state.webApp.qsns,
    guestbeneagentAppNum: state.webApp.guestbeneagentAppNum,
    appNum: state.webApp.appNum,
    agentEmailId: state.login.agentEmailId,
    pcpDetails: state.webApp.pcpDetails,
    questionDate: state.webApp.questionDate,
    count: state.webApp.count,
    Submitted: state.webApp.Submitted,
    emailoptionChecked: state.webApp.emailoptionChecked,
    spin: state.spinner.isLoading,
    isAgentRole: state.webApp.isAgentRole,
    isSuperUser: state.webApp.isSuperUser,
    planType: state.webApp.planType,
    cityList: state.login.cityList,
    isCaptchaValidated: state.webApp.isCaptchaValidated,
    customerId: state.login.customerId,
    dpemail: state.login.dpemail,
    beneficiaryLogin: state.login.beneficiaryLogin,
    uploadedFilesInPreEnroll: state.webApp.uploadedFilesInPreEnroll,
    leadIdNbrpayload: state.webApp.leadIdNbr,
    ltcList: state.login.ltcList,
    attachmentListpdf: state.webApp.attachmentList,
    mailzipCodes: state.campaignProspect.mailzipCodes,
    theme: state.login.theme,
    MBIDetails: state.login.mbiDetails,
    subDomain: state.login.subDomain,
    electionList: state.webApp.electionList,
    sepReasonforS: state.login.sepReasonforS,
    firstName: state.login.firstName,
    lastName: state.login.lastName,
    agentTaxId: state.login.agentTaxId,
    typeOfFilesToUpload: state.spinner.fileTypes,
  };
};

const mapDispatchToProps = {
  getsepReasons,
  setLoginStateValues,
  downloadFormsPdf,
  mbiDetails,
  getMailZipCodes,
  getStates,
  planSelectionContinue,
  saveLogout,
  submitForm,
  getClinicalName,
  removeplan,
  checkEligibility,
  getZipCodes,
  setStateParams,
  setCampaignProspectStateParams,
  setLoginStateParams,
  getPlans,
  uploadFile,
  uploadSign,
  deleteFile,
  setPendingApplFlag,
  LogoutToken,
  setTokenTORedux,
  setSpinner,
  getCityList,
  getltcList,
  //captchaValidation,
  setPageName,
  getPcpList,
  setPcpData,
  getAgentList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PreEnrollForm));
